import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.taiko');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

const YOUTUBE_SEARCH_URL = 'https://www.youtube.com/results';
const ONI_ICON_SRC = '/assets/icon/oni_icon.png';
const URA_ONI_ICON_SRC = '/assets/icon/ura_oni_icon.png';
const THEME_STORAGE_KEY = 'taigo_theme_mode';
const MY_DAN_STORAGE_KEY = 'taigo_taiko_my_dan';
const HIROBA_UPDATE_POLL_INTERVAL_MS = 5000;
const HIROBA_UPDATE_POLL_TIMEOUT_MS = 10 * 60 * 1000;
const HIROBA_HOME_URL = 'https://donderhiroba.jp/';
const HIROBA_WINDOW_NAME = 'taigo_taiko_hiroba_update';
const HIROBA_WINDOW_FEATURES = 'popup,width=520,height=760,left=80,top=60,resizable=yes,scrollbars=yes';
type ThemeMode = 'dark' | 'light';
type SortMode = 'tier' | 'clear' | 'score' | 'rival1' | 'rival2' | 'rival3';
type TaikoViewMode = 'level' | 'dan';
declare const WizRoute: any;

@Component({
    selector: 'wiz-page-taiko',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.taiko/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}

.taiko-root {
  transition: background-color 0.18s ease, color 0.18s ease;
}

.taigo-theme-toggle {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid #3f3f46;
  border-radius: 8px;
  background: #18181b;
  color: #d4d4d8;
  transition: border-color 0.18s ease, background-color 0.18s ease, color 0.18s ease;
}

.taigo-theme-toggle:hover {
  border-color: #22d3ee;
  color: #67e8f9;
}

.taigo-theme-toggle svg {
  width: 15px;
  height: 15px;
}

:host-context([data-taigo-theme=light]) .taiko-root {
  background: #f4f4f5 !important;
  color: #18181b !important;
}

:host-context([data-taigo-theme=light]) .taigo-theme-toggle {
  border-color: #d4d4d8;
  background: #ffffff;
  color: #3f3f46;
}

:host-context([data-taigo-theme=light]) .taigo-theme-toggle:hover {
  border-color: #0891b2;
  color: #0e7490;
}

:host-context([data-taigo-theme=light]) .bg-zinc-950,
:host-context([data-taigo-theme=light]) [class~=bg-zinc-950] {
  background-color: #f4f4f5 !important;
}

:host-context([data-taigo-theme=light]) .bg-zinc-900,
:host-context([data-taigo-theme=light]) [class~=bg-zinc-900],
:host-context([data-taigo-theme=light]) [class~="bg-zinc-900/95"],
:host-context([data-taigo-theme=light]) [class~="bg-zinc-900/70"],
:host-context([data-taigo-theme=light]) [class~="bg-zinc-900/50"] {
  background-color: #ffffff !important;
}

:host-context([data-taigo-theme=light]) .bg-zinc-800,
:host-context([data-taigo-theme=light]) [class~=bg-zinc-800],
:host-context([data-taigo-theme=light]) [class~="bg-zinc-800/70"],
:host-context([data-taigo-theme=light]) [class~="bg-zinc-800/60"],
:host-context([data-taigo-theme=light]) [class~="bg-zinc-800/50"],
:host-context([data-taigo-theme=light]) [class~="bg-zinc-800/30"] {
  background-color: #e4e4e7 !important;
}

:host-context([data-taigo-theme=light]) .bg-zinc-700,
:host-context([data-taigo-theme=light]) [class~=bg-zinc-700],
:host-context([data-taigo-theme=light]) [class~="bg-zinc-700/50"] {
  background-color: #d4d4d8 !important;
}

:host-context([data-taigo-theme=light]) .text-white,
:host-context([data-taigo-theme=light]) .text-zinc-100,
:host-context([data-taigo-theme=light]) .text-zinc-200,
:host-context([data-taigo-theme=light]) [class~=text-white],
:host-context([data-taigo-theme=light]) [class~=text-zinc-100],
:host-context([data-taigo-theme=light]) [class~=text-zinc-200] {
  color: #18181b !important;
}

:host-context([data-taigo-theme=light]) .text-zinc-300,
:host-context([data-taigo-theme=light]) [class~=text-zinc-300] {
  color: #3f3f46 !important;
}

:host-context([data-taigo-theme=light]) .text-zinc-400,
:host-context([data-taigo-theme=light]) [class~=text-zinc-400] {
  color: #52525b !important;
}

:host-context([data-taigo-theme=light]) .text-zinc-500,
:host-context([data-taigo-theme=light]) [class~=text-zinc-500] {
  color: #71717a !important;
}

:host-context([data-taigo-theme=light]) .text-zinc-600,
:host-context([data-taigo-theme=light]) [class~=text-zinc-600] {
  color: #a1a1aa !important;
}

:host-context([data-taigo-theme=light]) .text-zinc-700,
:host-context([data-taigo-theme=light]) [class~=text-zinc-700] {
  color: #d4d4d8 !important;
}

:host-context([data-taigo-theme=light]) [class~=bg-pink-500][class~=text-white],
:host-context([data-taigo-theme=light]) [class~=bg-rose-500][class~=text-white],
:host-context([data-taigo-theme=light]) [class~=bg-sky-500][class~=text-white],
:host-context([data-taigo-theme=light]) [class~=bg-pink-500] .text-white,
:host-context([data-taigo-theme=light]) [class~=bg-rose-500] .text-white,
:host-context([data-taigo-theme=light]) [class~=bg-sky-500] .text-white {
  color: #ffffff !important;
}

:host-context([data-taigo-theme=light]) .border-zinc-800,
:host-context([data-taigo-theme=light]) [class~=border-zinc-800] {
  border-color: #d4d4d8 !important;
}

:host-context([data-taigo-theme=light]) .border-zinc-700,
:host-context([data-taigo-theme=light]) [class~=border-zinc-700] {
  border-color: #c4c4ca !important;
}

:host-context([data-taigo-theme=light]) .border-zinc-600,
:host-context([data-taigo-theme=light]) [class~=border-zinc-600] {
  border-color: #a1a1aa !important;
}

:host-context([data-taigo-theme=light]) input[class~=bg-zinc-700],
:host-context([data-taigo-theme=light]) input[class~=bg-zinc-800] {
  background-color: #ffffff !important;
  color: #18181b !important;
}

:host-context([data-taigo-theme=light]) input::placeholder {
  color: #a1a1aa;
}

.taiko-root {
  min-height: 100vh;
  background: #09090b;
  color: #f4f4f5;
}

.taiko-root.theme-light {
  background: #f4f4f5;
  color: #18181b;
}

.taiko-wrap {
  width: min(100%, 1120px);
  margin: 0 auto;
  padding-right: 10px;
  padding-left: 10px;
}

.taiko-header {
  border-bottom: 1px solid #27272a;
  background: rgba(24, 24, 27, 0.96);
}

.taiko-root.theme-light .taiko-header {
  border-bottom-color: #d4d4d8;
  background: rgba(250, 250, 250, 0.96);
}

.taiko-header-inner {
  padding-top: 6px;
  padding-bottom: 7px;
}

.taiko-title-line {
  align-items: center;
  gap: 12px;
}

.taiko-title-block {
  min-width: 0;
}

.taiko-title-icon {
  width: 24px;
  height: 24px;
}

.taiko-title-block h1 {
  margin: 0;
  color: #f4f4f5;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
}

.taiko-root.theme-light .taiko-title-block h1 {
  color: #18181b;
}

.taiko-nav {
  flex-shrink: 0;
  color: #a1a1aa;
  font-size: 12px;
}

.taiko-root.theme-light .taiko-nav {
  color: #52525b;
}

.taiko-header .taigo-theme-toggle {
  border-radius: 0;
  padding: 0;
}

.taiko-user-actions button,
.taiko-user-actions span {
  line-height: 1;
}

.taiko-genre-legend,
.taiko-legend,
.taiko-stats {
  color: #a1a1aa;
}

.taiko-root.theme-light .taiko-genre-legend,
.taiko-root.theme-light .taiko-legend,
.taiko-root.theme-light .taiko-stats {
  color: #52525b;
}

.taiko-level-tabs {
  min-width: 0;
  overflow-x: auto;
  padding-bottom: 1px;
}

.taiko-level-tab {
  display: inline-flex;
  flex: 0 0 auto;
  min-width: 42px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid #3f3f46;
  background: #18181b;
  color: #a1a1aa;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.taiko-level-tab:hover {
  border-color: #52525b;
  color: #f4f4f5;
}

.taiko-level-tab.is-active {
  border-width: 2px;
  border-color: #22d3ee;
  background: #164e63;
  color: #ecfeff;
}

.taiko-root.theme-light .taiko-level-tab {
  border-color: #d4d4d8;
  background: #ffffff;
  color: #52525b;
}

.taiko-root.theme-light .taiko-level-tab:hover {
  border-color: #a1a1aa;
  color: #18181b;
}

.taiko-root.theme-light .taiko-level-tab.is-active {
  border-color: #155e75;
  background: #ecfeff;
  color: #155e75;
}

.taiko-dan-tab {
  margin-left: 6px;
}

.taiko-dan-panel {
  overflow: hidden;
  border: 1px solid rgba(236, 72, 153, 0.28);
  border-radius: 12px;
  background: rgba(24, 24, 27, 0.72);
}

.taiko-dan-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid #27272a;
  background: rgba(24, 24, 27, 0.94);
}

.taiko-dan-head h2 {
  margin: 0;
  color: #f4f4f5;
  font-size: 15px;
  font-weight: 800;
}

.taiko-dan-head > span {
  flex-shrink: 0;
  border: 1px solid rgba(236, 72, 153, 0.22);
  border-radius: 999px;
  padding: 5px 9px;
  color: #f9a8d4;
  background: rgba(236, 72, 153, 0.1);
  font-size: 11px;
  font-weight: 700;
}

.taiko-my-dan {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
  margin-left: 6px;
  min-width: 0;
}

.taiko-my-dan label {
  color: #d4d4d8;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.taiko-my-dan input {
  width: 132px;
  height: 30px;
  border: 1px solid #3f3f46;
  border-radius: 0;
  padding: 0 8px;
  outline: none;
  color: #f4f4f5;
  background: #18181b;
  font-size: 12px;
}

.taiko-my-dan input:focus {
  border-color: #ec4899;
  box-shadow: 0 0 0 2px rgba(236, 72, 153, 0.15);
}

@media (max-width: 639px) {
  .taiko-my-dan input {
    width: 120px;
  }
}
.taiko-dan-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));
  gap: 1px;
  background: rgba(63, 63, 70, 0.5);
}

.taiko-dan-card {
  min-width: 0;
  padding: 13px;
  background: #18181b;
}

.taiko-dan-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.taiko-dan-card-head > div {
  min-width: 0;
}

.taiko-dan-card-head h3 {
  margin: 0;
  color: #f4f4f5;
  font-size: 16px;
  font-weight: 800;
}

.taiko-dan-criteria {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin: 4px 0 0;
  color: #a1a1aa;
  font-size: 11px;
  line-height: 1.35;
}

.taiko-dan-summary {
  margin-top: 10px;
  display: grid;
  gap: 6px;
}

.taiko-dan-summary-head {
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
}

.taiko-dan-summary-head span {
  color: #a5f3fc;
  font-size: 10px;
  font-weight: 800;
}

.taiko-dan-summary-head b {
  color: #f4f4f5;
  font-size: 18px;
  line-height: 1;
}

.taiko-dan-summary-head em {
  color: #67e8f9;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
}

.taiko-dan-summary.is-empty .taiko-dan-summary-head span,
.taiko-dan-summary.is-empty .taiko-dan-summary-head b,
.taiko-dan-summary.is-empty .taiko-dan-summary-head em {
  color: #71717a;
}

.taiko-dan-summary-bar {
  overflow: hidden;
  height: 4px;
  border-radius: 999px;
  background: #27272a;
}

.taiko-dan-summary-bar span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #ec4899, #22d3ee);
}

.taiko-dan-summary-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  color: #a1a1aa;
  font-size: 10px;
  line-height: 1.2;
}

.taiko-dan-metrics {
  display: grid;
  gap: 6px;
  margin-top: 4px;
}

.taiko-dan-metric {
  display: grid;
  gap: 3px;
}

.taiko-dan-metric-head {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: baseline;
  gap: 6px;
  font-size: 10px;
  line-height: 1.2;
}

.taiko-dan-metric-head span {
  color: #d4d4d8;
  font-weight: 800;
}

.taiko-dan-metric-head b {
  min-width: 0;
  overflow: hidden;
  color: #f4f4f5;
  font-size: 11px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.taiko-dan-metric-head small,
.taiko-dan-metric-note {
  color: #a1a1aa;
  font-size: 10px;
}

.taiko-dan-metric-bar {
  overflow: hidden;
  height: 5px;
  border-radius: 999px;
  background: #27272a;
}

.taiko-dan-metric-bar span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #22d3ee;
}

.taiko-dan-metric.is-pass .taiko-dan-metric-bar span {
  background: #34d399;
}

.taiko-dan-metric.is-fail .taiko-dan-metric-bar span {
  background: #f97316;
}

.taiko-dan-metric.is-missing .taiko-dan-metric-bar span {
  background: #52525b;
}

.taiko-dan-metric.is-missing .taiko-dan-metric-head span,
.taiko-dan-metric.is-missing .taiko-dan-metric-head b,
.taiko-dan-metric.is-missing .taiko-dan-metric-head small,
.taiko-dan-metric.is-missing .taiko-dan-metric-note {
  color: #71717a;
}

.taiko-dan-status {
  flex-shrink: 0;
  border: 1px solid rgba(244, 114, 182, 0.28);
  border-radius: 999px;
  padding: 5px 8px;
  color: #f9a8d4;
  background: rgba(236, 72, 153, 0.08);
  font-size: 11px;
  font-weight: 800;
}

.taiko-dan-status.is-passed {
  border-color: rgba(52, 211, 153, 0.38);
  color: #6ee7b7;
  background: rgba(16, 185, 129, 0.12);
}

.taiko-dan-songs {
  display: grid;
  gap: 5px;
  margin-top: 12px;
}

.taiko-dan-song {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  min-width: 0;
  border: 1px solid #27272a;
  border-radius: 6px;
  padding: 6px 7px;
  background: rgba(9, 9, 11, 0.44);
}

.taiko-dan-song.is-satisfied {
  border-color: rgba(52, 211, 153, 0.28);
  background: rgba(16, 185, 129, 0.08);
}

.taiko-dan-song-main {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}

.taiko-dan-song-main img {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.taiko-dan-song-main div {
  min-width: 0;
}

.taiko-dan-song-main strong,
.taiko-dan-song-main small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.taiko-dan-song-main strong {
  color: #f4f4f5;
  font-size: 12px;
  line-height: 1.25;
}

.taiko-dan-song-main small {
  margin-top: 2px;
  color: #a1a1aa;
  font-size: 10px;
}

.taiko-dan-record {
  min-width: 66px;
  text-align: right;
}

.taiko-dan-record span {
  color: #d4d4d8;
  font-size: 10px;
  white-space: nowrap;
}

.taiko-dan-empty {
  padding: 28px 16px;
  color: #71717a;
  text-align: center;
  font-size: 13px;
}

.taiko-root.theme-light .taiko-dan-panel,
.taiko-root.theme-light .taiko-dan-card {
  background: #ffffff;
}

.taiko-root.theme-light .taiko-dan-head {
  border-bottom-color: #d4d4d8;
  background: #ffffff;
}

.taiko-root.theme-light .taiko-my-dan label {
  color: #3f3f46;
}

.taiko-root.theme-light .taiko-my-dan input {
  border-color: #d4d4d8;
  color: #18181b;
  background: #ffffff;
}

.taiko-root.theme-light .taiko-dan-head h2,
.taiko-root.theme-light .taiko-dan-card-head h3,
.taiko-root.theme-light .taiko-dan-song-main strong {
  color: #18181b;
}

.taiko-root.theme-light .taiko-dan-criteria,
.taiko-root.theme-light .taiko-dan-song-main small {
  color: #71717a;
}

.taiko-root.theme-light .taiko-dan-summary-head span,
.taiko-root.theme-light .taiko-dan-summary-head em {
  color: #0e7490;
}

.taiko-root.theme-light .taiko-dan-summary-head b {
  color: #18181b;
}

.taiko-root.theme-light .taiko-dan-summary-bar {
  background: #d4d4d8;
}

.taiko-root.theme-light .taiko-dan-summary-meta {
  color: #71717a;
}

.taiko-root.theme-light .taiko-dan-metric-head span,
.taiko-root.theme-light .taiko-dan-metric-head b {
  color: #18181b;
}

.taiko-root.theme-light .taiko-dan-metric-head small,
.taiko-root.theme-light .taiko-dan-metric-note {
  color: #71717a;
}

.taiko-root.theme-light .taiko-dan-metric-bar {
  background: #e4e4e7;
}

.taiko-root.theme-light .taiko-dan-song {
  border-color: #d4d4d8;
  background: #f4f4f5;
}

.taiko-progress {
  max-width: 420px;
  height: 4px;
  border-radius: 0;
  background: #27272a;
}

.taiko-root.theme-light .taiko-progress {
  background: #d4d4d8;
}

.taiko-scroll {
  scrollbar-width: thin;
  scrollbar-color: #71717a transparent;
}

.taiko-scroll::-webkit-scrollbar {
  height: 5px;
}

.taiko-scroll::-webkit-scrollbar-thumb {
  background: #71717a;
}

.taiko-main {
  padding-top: 7px;
  padding-bottom: 24px;
}

.taiko-login-notice,
.taiko-weekly-panel {
  overflow: hidden;
  border: 1px solid #3f3f46;
  border-radius: 0;
  background: #18181b;
  color: #a1a1aa;
}

.taiko-root.theme-light .taiko-login-notice,
.taiko-root.theme-light .taiko-weekly-panel {
  border-color: #d4d4d8;
  background: #ffffff;
  color: #52525b;
}

.taiko-weekly-head {
  border-bottom: 1px solid #3f3f46;
  background: #18181b;
}

.taiko-root.theme-light .taiko-weekly-head {
  border-bottom-color: #d4d4d8;
  background: #ffffff;
}

.taiko-weekly-mark {
  border-radius: 0;
  background: #164e63;
  color: #ecfeff;
}

.taiko-root.theme-light .taiko-weekly-mark {
  background: #ecfeff;
  color: #155e75;
}

.taiko-weekly-grid {
  gap: 0;
  background: #3f3f46;
  padding: 0;
}

.taiko-root.theme-light .taiko-weekly-grid {
  background: #d4d4d8;
}

.taiko-weekly-card {
  border-right: 1px solid #3f3f46;
  border-bottom: 1px solid #3f3f46;
  background: #18181b;
}

.taiko-weekly-card:hover {
  background: #27272a;
}

.taiko-root.theme-light .taiko-weekly-card {
  border-color: #e4e4e7;
  background: #ffffff;
}

.taiko-root.theme-light .taiko-weekly-card:hover {
  background: #f4f4f5;
}

.taiko-search-panel {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
}

.taiko-search-input-shell {
  display: flex;
  min-width: 0;
  height: 34px;
  align-items: center;
  border: 1px solid #3f3f46;
  background: #18181b;
  color: #a1a1aa;
}

.taiko-root.theme-light .taiko-search-input-shell {
  border-color: #d4d4d8;
  background: #ffffff;
  color: #52525b;
}

.taiko-search-icon {
  width: 15px;
  height: 15px;
  margin-left: 10px;
  flex: 0 0 auto;
  color: #71717a;
}

.taiko-search-input {
  width: 100%;
  min-width: 0;
  height: 100%;
  border: 0;
  background: transparent;
  color: #f4f4f5;
  padding: 0 9px;
  font-size: 12px;
  font-weight: 500;
  outline: 0;
}

.taiko-root.theme-light .taiko-search-input {
  color: #18181b;
}

.taiko-search-input::placeholder {
  color: #71717a;
}

.taiko-root.theme-light .taiko-search-input::placeholder {
  color: #a1a1aa;
}

.taiko-search-clear {
  display: inline-flex;
  width: 31px;
  height: 100%;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 0;
  border-left: 1px solid #3f3f46;
  background: transparent;
  color: #71717a;
  padding: 0;
}

.taiko-search-clear:hover {
  color: #f4f4f5;
}

.taiko-root.theme-light .taiko-search-clear {
  border-left-color: #d4d4d8;
}

.taiko-root.theme-light .taiko-search-clear:hover {
  color: #18181b;
}

.taiko-search-clear svg {
  width: 14px;
  height: 14px;
}

.taiko-search-summary {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  color: #a1a1aa;
  font-size: 11px;
  white-space: nowrap;
}

.taiko-search-summary span {
  display: inline-flex;
  height: 22px;
  align-items: center;
  border: 1px solid #3f3f46;
  background: #18181b;
  padding: 0 7px;
}

.taiko-root.theme-light .taiko-search-summary {
  color: #52525b;
}

.taiko-root.theme-light .taiko-search-summary span {
  border-color: #d4d4d8;
  background: #ffffff;
}

.taiko-empty-search {
  border: 1px solid #3f3f46;
  background: #18181b;
  color: #71717a;
  padding: 26px 12px;
  text-align: center;
  font-size: 13px;
}

.taiko-root.theme-light .taiko-empty-search {
  border-color: #d4d4d8;
  background: #ffffff;
  color: #71717a;
}

.taiko-table {
  border-top: 1px solid #52525b;
  border-left: 1px solid #52525b;
  background: #18181b;
}

.taiko-root.theme-light .taiko-table {
  border-color: #a1a1aa;
  background: #ffffff;
}

.taiko-section-controls {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(150px, 210px);
  align-items: center;
  gap: 6px;
}

.taiko-section-tabs {
  display: flex;
  gap: 4px;
  min-width: 0;
  overflow-x: auto;
  padding-bottom: 1px;
}

.taiko-sort-toggle,
.taiko-section-tab {
  display: inline-flex;
  flex: 0 0 auto;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid #3f3f46;
  background: #18181b;
  color: #a1a1aa;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.taiko-section-tab {
  min-width: 42px;
}

.taiko-sort-toggle {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.taiko-sort-toggle:hover,
.taiko-section-tab:hover {
  border-color: #52525b;
  color: #f4f4f5;
}

.taiko-section-tab.is-active {
  border-width: 2px;
  border-color: #22d3ee;
  background: #164e63;
  color: #ecfeff;
}

.taiko-root.theme-light .taiko-sort-toggle,
.taiko-root.theme-light .taiko-section-tab {
  border-color: #d4d4d8;
  background: #ffffff;
  color: #52525b;
}

.taiko-root.theme-light .taiko-sort-toggle:hover,
.taiko-root.theme-light .taiko-section-tab:hover {
  border-color: #a1a1aa;
  color: #18181b;
}

.taiko-root.theme-light .taiko-section-tab.is-active {
  border-color: #52525b;
  background: #e4e4e7;
  color: #18181b;
}

.taiko-tier-row {
  display: grid;
  grid-template-columns: 142px minmax(0, 1fr);
  overflow: visible;
  border: 0;
  border-bottom: 1px solid #52525b;
  border-radius: 0;
  background: transparent;
}

.taiko-root.theme-light .taiko-tier-row {
  border-bottom-color: #a1a1aa;
}

.taiko-tier-label {
  display: flex;
  min-height: 54px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-right: 1px solid #52525b;
  padding: 6px;
  cursor: pointer;
  text-align: center;
}

.taiko-root.theme-light .taiko-tier-label {
  border-right-color: #a1a1aa;
  background: #ffffff !important;
  color: #18181b !important;
}

.taiko-tier-label.is-active {
  box-shadow: inset 0 0 0 2px rgba(34, 211, 238, 0.58);
}

.taiko-root.theme-light .taiko-tier-label.is-active {
  box-shadow: inset 0 0 0 2px #71717a;
}

.taiko-tier-title {
  justify-content: center;
  gap: 6px;
}

.taiko-tier-name {
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.15;
}

.taiko-tier-count,
.taiko-tier-rate {
  color: currentColor;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  opacity: 0.72;
  white-space: nowrap;
}

.taiko-tier-clear {
  justify-content: center;
  gap: 5px;
}

.taiko-tier-progress {
  width: 52px;
  height: 4px;
  border-radius: 0;
}

.taiko-song-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 0;
  padding: 0;
  background: transparent;
}

.taiko-song-cell {
  position: relative;
  min-width: 0;
  min-height: 66px;
  overflow: hidden;
  border-right: 1px solid #3f3f46;
  border-bottom: 1px solid #3f3f46;
  background: #18181b;
}

.taiko-root.theme-light .taiko-song-cell {
  border-right-color: #d4d4d8;
  border-bottom-color: #e4e4e7;
  background: #ffffff;
}

.taiko-song-surface {
  min-height: 66px;
  background: #18181b;
}

.taiko-song-cell:hover .taiko-song-surface {
  background: #27272a;
}

.taiko-root.theme-light .taiko-song-surface {
  background: #ffffff;
}

.taiko-root.theme-light .taiko-song-cell:hover .taiko-song-surface {
  background: #ffffff;
}

.taiko-root.theme-dark .taiko-song-surface[class~="bg-orange-950/30"] {
  background: #27160d;
}

.taiko-root.theme-dark .taiko-song-surface[class~="bg-zinc-700/30"] {
  background: #27272a;
}

.taiko-root.theme-dark .taiko-song-surface[class~="bg-yellow-950/30"] {
  background: #26210b;
}

.taiko-root.theme-dark .taiko-song-surface[class~="bg-indigo-950/30"] {
  background: #1e1b35;
}

.taiko-root.theme-light .taiko-song-surface[class~=bg-orange-100] {
  background: #ffffff;
}

.taiko-root.theme-light .taiko-song-surface[class~=bg-zinc-100] {
  background: #ffffff;
}

.taiko-root.theme-light .taiko-song-surface[class~=bg-yellow-100] {
  background: #ffffff;
}

.taiko-root.theme-light .taiko-song-surface[class~=bg-indigo-100] {
  background: #ffffff;
}

.taiko-genre-line {
  width: 7px;
  border-radius: 0;
}

.taiko-song-body {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 5px 6px;
}

.taiko-song-top {
  min-width: 0;
  align-items: flex-start;
  gap: 4px;
}

.taiko-song-title-row {
  min-width: 0;
  align-items: center;
  gap: 4px;
}

.taiko-song-title-row img,
.taiko-song-title-row svg,
.taiko-song-title-row .crown-rainbow-mask {
  width: 14px;
  height: 14px;
}

.taiko-song-title {
  min-width: 0;
  overflow: hidden;
  color: #f4f4f5;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.taiko-root.theme-light .taiko-song-title {
  color: #18181b;
}

.taiko-song-subtitle {
  overflow: hidden;
  color: #a1a1aa;
  font-size: 10px;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.taiko-root.theme-light .taiko-song-subtitle {
  color: #71717a;
}

.taiko-title-tooltip {
  position: fixed;
  z-index: 80;
  max-width: min(420px, 100vw - 16px);
  border: 1px solid #3f3f46;
  border-radius: 4px;
  background: #18181b;
  box-shadow: 0 10px 24px rgba(24, 24, 27, 0.28);
  color: #f4f4f5;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  padding: 6px 8px;
  pointer-events: none;
  text-align: center;
  transform: translate(-50%, -100%);
  white-space: normal;
}

.taiko-title-tooltip.is-below {
  transform: translate(-50%, 0);
}

.taiko-card-actions {
  width: 52px;
  min-height: 17px;
  justify-content: flex-end;
}

.taiko-card-actions a,
.taiko-card-actions button {
  display: inline-flex;
  width: 17px;
  height: 17px;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  padding: 0;
  color: #a1a1aa;
}

.taiko-card-actions a:hover,
.taiko-card-actions button:hover {
  color: #67e8f9;
}

.taiko-song-record {
  display: flex;
  width: 100%;
  max-width: 100%;
  min-height: 14px;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  overflow: hidden;
  margin-top: auto;
  padding-right: 0;
}

.taiko-score-row {
  width: 100%;
  min-width: 0;
  white-space: nowrap;
}

.taiko-score-display {
  display: inline-flex;
  max-width: 100%;
  min-height: 14px;
  align-items: center;
  border-radius: 0;
  margin: 0;
  padding: 0 1px;
}

.taiko-score-display:hover {
  background: transparent;
}

.taiko-score-text {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 9px;
  font-weight: 500;
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.taiko-score-placeholder {
  display: inline-flex;
  height: 14px;
  align-items: center;
  color: #71717a;
  font-size: 9px;
  line-height: 1;
}

.taiko-root.theme-light .taiko-score-placeholder {
  color: #a1a1aa;
}

.taiko-score-input {
  height: 18px;
  border-radius: 0;
  background: #27272a;
  color: #f4f4f5;
}

.taiko-root.theme-light .taiko-score-input {
  border-color: #d4d4d8;
  background: #ffffff;
  color: #18181b;
}

.taiko-rival-compare {
  display: grid;
  width: 100%;
  min-width: 0;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 4px;
  color: #a1a1aa;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 9px;
  line-height: 1.1;
}

.taiko-rival-name,
.taiko-rival-diff {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.taiko-rival-name {
  color: #a1a1aa;
}

.taiko-rival-diff {
  font-weight: 700;
}

.taiko-rival-compare.is-lose .taiko-rival-diff {
  color: #fb7185;
}

.taiko-rival-compare.is-win .taiko-rival-diff {
  color: #22c55e;
}

.taiko-rival-compare.is-even .taiko-rival-diff {
  color: #a1a1aa;
}

.taiko-root.theme-light .taiko-rival-compare,
.taiko-root.theme-light .taiko-rival-name {
  color: #71717a;
}

.taiko-empty-section {
  border-right: 1px solid #3f3f46;
  color: #71717a;
}

.taiko-root.theme-light .taiko-empty-section {
  border-right-color: #d4d4d8;
}

.taiko-footer {
  color: #71717a;
}

@media (max-width: 980px) {
  .taiko-song-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .taiko-title-line {
    align-items: flex-start;
  }
  .taiko-nav {
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 6px;
  }
}
@media (max-width: 640px) {
  .taiko-wrap {
    padding-right: 6px;
    padding-left: 6px;
  }
  .taiko-title-block h1 {
    font-size: 15px;
  }
  .taiko-title-icon {
    width: 22px;
    height: 22px;
  }
  .taiko-tier-row {
    grid-template-columns: 76px minmax(0, 1fr);
  }
  .taiko-tier-name {
    font-size: 12px;
  }
  .taiko-tier-count,
  .taiko-tier-progress {
    display: none;
  }
  .taiko-section-controls {
    grid-template-columns: 1fr;
  }
  .taiko-search-panel {
    grid-template-columns: 1fr;
  }
  .taiko-search-summary {
    justify-content: flex-start;
    overflow-x: auto;
  }
  .taiko-sort-toggle {
    width: 100%;
  }
  .taiko-song-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .taiko-song-cell,
  .taiko-song-surface {
    min-height: 70px;
  }
  .taiko-card-actions {
    width: 42px;
  }
}
.crown-rainbow-mask {
  display: inline-block;
  background: linear-gradient(90deg, #ff6b6b, #ffa500, #ffd700, #48bb78, #4299e1, #9f7aea);
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M5 16L3 5l5.5 5L12 4l3.5 6L21 5l-2 11H5z'/%3E%3Cpath d='M5 17h14v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2z'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M5 16L3 5l5.5 5L12 4l3.5 6L21 5l-2 11H5z'/%3E%3Cpath d='M5 17h14v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2z'/%3E%3C/svg%3E");
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
}

.score-rainbow {
  background: linear-gradient(90deg, #ff6b6b, #ffa500, #ffd700, #48bb78, #4299e1, #9f7aea);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.score-rainbow-bg {
  background: linear-gradient(90deg, #ff6b6b, #ffa500, #ffd700, #48bb78, #4299e1, #9f7aea);
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.auth-modal-enter {
  animation: modalSlideUp 0.2s ease-out;
}

@keyframes modalSlideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}`],
})
export class PageTaikoComponent implements OnInit, OnDestroy {
    public levels: number[] = [6, 7, 8, 9, 10];
    public currentLevel: number = 10;
    public viewMode: TaikoViewMode = 'level';
    public allSections: any[] = [];
    public sections: any[] = [];
    public selectedSections: string[] = [];
    public songs: any = {};
    public danCourses: any[] = [];
    public myDan: string = '';
    public loading: boolean = true;
    public themeMode: ThemeMode = 'dark';
    public sortMode: SortMode = 'tier';
    public allData: any = null;
    public titleTooltip: any = { visible: false, text: '', left: 0, top: 0, placement: 'above' };
    public searchText: string = '';
    public searchSummary: any = { query: '', total: 0, direct: 0, similar: 0 };
    private routerSub: Subscription | null = null;
    private saveTimer: any = null;
    private readonly sortModeOrder: SortMode[] = ['tier', 'clear', 'score', 'rival1', 'rival2', 'rival3'];
    private readonly similarSearchThreshold: number = 0.38;
    private difficultyIconImagePromise: Promise<{ oni: HTMLImageElement; ura: HTMLImageElement }> | null = null;

    public user: any = null;
    public isLoggedIn: boolean = false;
    public songData: any = {};
    public rivalInfo: any = { enabled: false, configured: false, resolved: false, rival: null, rivals: [], message: '', scoreCount: 0 };
    public rivalScores: any = {};
    public rivalScoresBySlot: any = {};
    public rivalLoading: boolean = false;
    public editingScoreKey: string = '';
    public editingScoreValue: string = '';
    public exportingChart: boolean = false;
    public levelStats: any = { total: 0, played: 0, clear: 0, fc: 0, dfc: 0 };
    public weeklyRecommendations: any[] = [];
    public weeklyKey: string = '';
    public weeklyRangeLabel: string = '';
    public weeklyBpmProfile: any = { weak: [], strong: [] };
    public weeklyPopularity: any = {};

    public showAuthModal: boolean = false;
    public authMode: 'login' | 'register' = 'login';
    public authEmail: string = '';
    public authPassword: string = '';
    public authName: string = '';
    public authError: string = '';
    public authLoading: boolean = false;

    public hirobaUpdateModalOpen: boolean = false;
    public hirobaUpdateInfo: any = { loggedIn: false, latest: null };
    public hirobaUpdateToken: string = '';
    public hirobaUpdateTokenExpires: string = '';
    public hirobaBookmarkletCode: string = '';
    public hirobaUpdateStatusMessage: string = '';
    public hirobaUpdateLoading: boolean = false;
    public hirobaCopiedTarget: string = '';
    private hirobaUpdatePollTimer: any = null;
    private hirobaUpdatePollStartedAt: number = 0;
    private hirobaUpdateBaselineUpdatedAt: number = 0;
    private hirobaUpdateWindow: Window | null = null;

    public sectionNameMap: any = {
        'F': '최하급', 'E': '하급', 'D': '중하급', 'C': '중급',
        'B': '중상급', 'A': '상급', 'S': '최상급', 'S+': '최상급+',
        'SS': '졸업', 'SSS': '졸업+', 'X': '개인차'
    };

    public crownList = [
        { key: 'none', label: '미플레이', color: 'transparent' },
        { key: 'played', label: '불클리어', color: '#CD7F32' },
        { key: 'clear', label: '클리어', color: '#C0C0C0' },
        { key: 'fc', label: '풀콤보', color: '#FFD700' },
        { key: 'dfc', label: '전량', color: 'rainbow' }
    ];

    private crownOrder = ['none', 'played', 'clear', 'fc', 'dfc'];

    private getCrownRank(crown: string): number {
        const idx = this.crownOrder.indexOf(crown || 'none');
        return idx >= 0 ? idx : 0;
    }

    private normalizeRecordScore(score: any): number {
        const value = Number(score) || 0;
        return Math.max(0, Math.min(Math.floor(value), 1200000));
    }

    private normalizeRecordCount(value: any): number {
        const parsed = Number(value) || 0;
        return Math.max(0, Math.min(Math.floor(parsed), 1200000));
    }

    private getRecordCount(record: any, ...aliases: string[]): number {
        if (!record || typeof record !== 'object') return 0;
        for (const alias of aliases) {
            if (Object.prototype.hasOwnProperty.call(record, alias)) {
                return this.normalizeRecordCount(record[alias]);
            }
        }
        return 0;
    }

    private mergeDetailStats(target: any, source: any): boolean {
        if (!target || typeof target !== 'object' || !source || typeof source !== 'object') return false;
        const mappings = [
            { key: 'good', aliases: ['good', 'goodCount', 'good_count', 'ryo', '良', '량'] },
            { key: 'ok', aliases: ['ok', 'okCount', 'ok_count', 'ka', '可', '가'] },
            { key: 'bad', aliases: ['bad', 'badCount', 'bad_count', 'ng', '不可', '불가'] },
            { key: 'maxCombo', aliases: ['maxCombo', 'max_combo', 'combo', 'comboCount', 'combo_count'] },
            { key: 'roll', aliases: ['roll', 'drumroll', 'drumRoll', 'drumrollCount', 'pound', 'poundCount', 'pound_count', 'renda'] }
        ];
        let changed = false;

        for (const mapping of mappings) {
            const hasValue = mapping.aliases.some((alias) => Object.prototype.hasOwnProperty.call(source, alias));
            if (!hasValue) continue;

            const nextValue = this.getRecordCount(source, ...mapping.aliases);
            const currentValue = this.getRecordCount(target, mapping.key, ...mapping.aliases);
            if (nextValue <= 0 && currentValue <= 0) continue;
            if (currentValue === nextValue) continue;

            target[mapping.key] = nextValue;
            if (mapping.key === 'maxCombo') target.max_combo = nextValue;
            changed = true;
        }

        return changed;
    }

    private applyHigherSongRecord(key: string, next: any): boolean {
        const nextRecord = typeof next === 'string' ? { crown: next, score: 0 } : (next || {});
        const nextCrown = typeof nextRecord?.crown === 'string' ? nextRecord.crown : 'none';
        const nextCrownRank = this.getCrownRank(nextCrown);
        const nextScore = this.normalizeRecordScore(nextRecord?.score);

        if (!this.songData[key]) {
            this.songData[key] = { crown: nextCrown, score: nextScore };
            this.mergeDetailStats(this.songData[key], nextRecord);
            return true;
        }

        if (typeof this.songData[key] !== 'object') {
            this.songData[key] = { crown: String(this.songData[key] || 'none'), score: 0 };
        }

        const current = this.songData[key];
        const currentCrownRank = this.getCrownRank(current.crown || 'none');
        const currentScore = this.normalizeRecordScore(current.score);
        let changed = false;

        if (nextCrownRank > currentCrownRank) {
            this.songData[key].crown = nextCrown;
            changed = true;
        }

        if (nextScore > currentScore) {
            this.songData[key].score = nextScore;
            changed = true;
        }

        return this.mergeDetailStats(this.songData[key], nextRecord) || changed;
    }

    public scoreRanks = [
        { min: 1000000, label: '무지개', color: 'rainbow' },
        { min: 950000, label: '보라', color: '#8B5CF6' },
        { min: 900000, label: '핑크', color: '#EC4899' },
        { min: 800000, label: '금색', color: '#EAB308' },
        { min: 700000, label: '은색', color: '#9CA3AF' },
        { min: 600000, label: '동색', color: '#CD7F32' },
        { min: 500000, label: '흰색', color: '#E5E7EB' },
        { min: 0, label: '', color: '#4B5563' }
    ];

    public genreColors: any = {
        pops: '#4fb5bd', anime: '#e28dc8', vocaloid: '#d0d0d0',
        classic: '#ccbd4a', variety: '#40c977', game: '#b697d3',
        namco: '#EB6B6A', kids: '#ebb850'
    };

    public genreLabels: any = {
        namco: '남코', vocaloid: '보컬로이드', game: '게임',
        variety: '버라이어티', classic: '클래식', pops: '팝스',
        anime: '애니메이션', kids: '키즈'
    };

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        this.themeMode = this.loadThemeMode();
        this.myDan = this.loadMyDan();
        this.applyThemeMode();
        await this.service.init();
        await this.checkAuth();
        await this.loadSongData();
        await this.loadRivalData();
        this.hirobaBookmarkletCode = this.buildHirobaBookmarkletCode();

        this.applyRouteLevel(WizRoute.segment.level);

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const previousMode = this.viewMode;
                const previousLevel = this.currentLevel;
                this.applyRouteLevel(WizRoute.segment.level);
                if (previousMode !== this.viewMode || previousLevel !== this.currentLevel) {
                    this.updateSections();
                    await this.service.render();
                }
            }
        });

        await this.load();
        await this.loadHirobaUpdateStatus(false);
        await this.loadWeeklyRecommendations(false);
        await this.service.render();
    }

    private applyRouteLevel(level: any) {
        const raw = String(level || '').trim().toLowerCase();
        if (raw === 'dan' || raw === 'unit' || raw === 'class') {
            this.viewMode = 'dan';
            return;
        }

        this.viewMode = 'level';
        if (!raw) {
            this.currentLevel = 10;
            return;
        }

        const nextLevel = parseInt(raw, 10);
        this.currentLevel = Number.isNaN(nextLevel) || nextLevel < 6 || nextLevel > 10 ? 10 : nextLevel;
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.saveTimer) clearTimeout(this.saveTimer);
        this.stopHirobaUpdateStatusPolling();
    }

    private loadThemeMode(): ThemeMode {
        try {
            const saved = localStorage.getItem(THEME_STORAGE_KEY);
            if (saved === 'dark' || saved === 'light') return saved;
        } catch { }
        return 'dark';
    }

    private loadMyDan(): string {
        try {
            return String(localStorage.getItem(MY_DAN_STORAGE_KEY) || '').slice(0, 30);
        } catch { }
        return '';
    }

    public saveMyDan() {
        this.myDan = String(this.myDan || '').trim().slice(0, 30);
        try {
            if (this.myDan) localStorage.setItem(MY_DAN_STORAGE_KEY, this.myDan);
            else localStorage.removeItem(MY_DAN_STORAGE_KEY);
        } catch { }
    }

    private applyThemeMode() {
        try {
            document.documentElement.setAttribute('data-taigo-theme', this.themeMode);
            document.documentElement.style.colorScheme = this.themeMode;
        } catch { }
    }

    public getThemeToggleLabel(): string {
        return this.themeMode === 'dark' ? '라이트 모드로 전환' : '다크 모드로 전환';
    }

    public async toggleThemeMode() {
        this.themeMode = this.themeMode === 'dark' ? 'light' : 'dark';
        try {
            localStorage.setItem(THEME_STORAGE_KEY, this.themeMode);
        } catch { }
        this.applyThemeMode();
        await this.service.render();
    }

    private async checkAuth() {
        try {
            const { code, data } = await wiz.call("check_auth");
            if (code === 200) {
                this.user = data;
                this.isLoggedIn = true;
            }
        } catch { }
    }

    private async loadSongData() {
        if (this.isLoggedIn) {
            try {
                const { code, data } = await wiz.call("load_scores");
                if (code === 200 && data) {
                    this.songData = data;
                }
            } catch { }
        } else {
            try {
                const saved = localStorage.getItem('taiko_songdata');
                if (saved) {
                    const parsed = JSON.parse(saved);
                    for (const [key, value] of Object.entries(parsed)) {
                        if (typeof value === 'string') {
                            this.songData[key] = { crown: value, score: 0 };
                        } else {
                            this.songData[key] = value;
                        }
                    }
                } else {
                    const oldSaved = localStorage.getItem('taiko_statuses');
                    if (oldSaved) {
                        const parsed = JSON.parse(oldSaved);
                        for (const [key, value] of Object.entries(parsed)) {
                            this.songData[key] = { crown: value as string, score: 0 };
                        }
                        localStorage.setItem('taiko_songdata', JSON.stringify(this.songData));
                        localStorage.removeItem('taiko_statuses');
                    }
                }
            } catch { }
        }
    }

    private clearRivalData() {
        this.rivalInfo = { enabled: false, configured: false, resolved: false, rival: null, rivals: [], message: '', scoreCount: 0 };
        this.rivalScores = {};
        this.rivalScoresBySlot = {};
        this.rivalLoading = false;
    }

    private async loadRivalData(render: boolean = false) {
        if (!this.isLoggedIn) {
            this.clearRivalData();
            if (render) await this.service.render();
            return;
        }

        this.rivalLoading = true;
        try {
            const { code, data } = await wiz.call("load_rival_scores", { _ts: Date.now() });
            if (code === 200 && data) {
                const rivals = Array.isArray(data.rivals) ? data.rivals : [];
                const scoresBySlot: any = {};
                for (const rival of rivals) {
                    const slot = Number(rival?.slot || 0);
                    if (slot >= 1 && slot <= 3) {
                        scoresBySlot[slot] = rival?.scores || {};
                    }
                }
                this.rivalInfo = {
                    enabled: !!data.enabled,
                    configured: !!data.configured,
                    resolved: !!data.resolved,
                    rivalId: data.rivalId || '',
                    rival: data.rival || null,
                    rivals,
                    message: data.message || '',
                    scoreCount: Number(data.scoreCount || 0)
                };
                this.rivalScoresBySlot = scoresBySlot;
                this.rivalScores = this.getRivalScoresForSlot(this.getActiveRivalSlot()) || data.scores || {};
            } else {
                this.clearRivalData();
            }
        } catch {
            this.clearRivalData();
        }

        this.rivalLoading = false;
        if (this.isRivalSortMode()) {
            this.applySectionFilters();
            this.updateLevelStats();
        }
        if (render) await this.service.render();
    }

    private saveSongData() {
        if (this.isLoggedIn) {
            if (this.saveTimer) clearTimeout(this.saveTimer);
            this.saveTimer = setTimeout(async () => {
                try {
                    await wiz.call("save_scores", { data: JSON.stringify(this.songData) });
                } catch { }
            }, 500);
        } else {
            localStorage.setItem('taiko_songdata', JSON.stringify(this.songData));
        }
    }

    public openAuthModal(mode: 'login' | 'register') {
        this.authMode = mode;
        this.authEmail = '';
        this.authPassword = '';
        this.authName = '';
        this.authError = '';
        this.authLoading = false;
        this.showAuthModal = true;
        this.service.render();
    }

    public closeAuthModal() {
        this.showAuthModal = false;
        this.authError = '';
        this.authLoading = false;
        this.service.render();
    }

    public switchAuthMode(mode: 'login' | 'register') {
        this.authMode = mode;
        this.authError = '';
        this.authLoading = false;
        this.service.render();
    }

    public onAuthKeydown(event: KeyboardEvent) {
        if (event.key !== 'Enter' || event.isComposing) return;
        event.preventDefault();
        this.submitAuth();
    }

    public async submitAuth() {
        if (this.authLoading) return;
        this.authError = '';

        const email = this.authEmail.trim();
        const password = this.authPassword;
        const name = this.authName.trim();

        if (!email || !password || (this.authMode === 'register' && !name)) {
            this.authError = this.authMode === 'login'
                ? '이메일과 비밀번호를 입력해주세요.'
                : '모든 필드를 입력해주세요.';
            await this.service.render();
            return;
        }

        this.authLoading = true;
        await this.service.render();

        try {
            if (this.authMode === 'login') {
                const { code, data } = await wiz.call("login", {
                    email: email,
                    password: password
                });
                if (code === 200) {
                    this.user = data;
                    this.isLoggedIn = true;
                    this.closeAuthModal();

                    const localData = localStorage.getItem('taiko_songdata');
                    if (localData) {
                        const parsed = JSON.parse(localData);
                        if (Object.keys(parsed).length > 0) {
                            let merged = false;
                            for (const [key, value] of Object.entries(parsed)) {
                                if (this.applyHigherSongRecord(key, value as any)) merged = true;
                            }
                            if (merged) this.saveSongData();
                            localStorage.removeItem('taiko_songdata');
                        }
                    }

                    await this.loadSongData();
                    await this.loadRivalData(false);
                    this.updateLevelStats();
                    this.updateWeeklyRecommendations();
                    await this.loadWeeklyRecommendations(false, true);
                    await this.service.render();
                } else {
                    this.authError = data?.message || '로그인에 실패했습니다.';
                }
            } else {
                const { code, data } = await wiz.call("register", {
                    email: email,
                    password: password,
                    name: name
                });
                if (code === 200) {
                    this.user = data;
                    this.isLoggedIn = true;
                    this.closeAuthModal();
                    await this.loadSongData();
                    await this.loadRivalData(false);
                    this.updateLevelStats();
                    this.updateWeeklyRecommendations();
                    await this.loadWeeklyRecommendations(false, true);
                    await this.service.render();
                } else {
                    this.authError = data?.message || '회원가입에 실패했습니다.';
                }
            }
        } catch {
            this.authError = '서버 연결에 실패했습니다.';
        }

        this.authLoading = false;
        await this.service.render();
    }

    public async logout() {
        try {
            await wiz.call("logout");
        } catch { }
        this.user = null;
        this.isLoggedIn = false;
        this.songData = {};
        this.clearRivalData();
        this.service.href('/auth');
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("load");
        if (code === 200) {
            this.allData = data;
            this.songs = data.songs || {};
            this.danCourses = Array.isArray(data.danCourses)
                ? data.danCourses.sort((left: any, right: any) => Number(left.order || 0) - Number(right.order || 0))
                : [];
            this.updateSections();
        }

        this.loading = false;
        await this.service.render();
    }

    private updateSections() {
        if (!this.allData || !this.allData.levels) return;
        const levelData = this.allData.levels[String(this.currentLevel)];
        if (levelData) {
            this.allSections = levelData.sections || [];
        } else {
            this.allSections = [];
        }
        this.selectedSections = this.selectedSections.filter((name) => this.allSections.some((section) => section.name === name));
        this.applySectionFilters();
        this.updateLevelStats();
        this.updateWeeklyRecommendations();
    }

    private applySectionFilters() {
        const sourceSections = this.selectedSections.length === 0
            ? this.allSections
            : this.allSections.filter((section) => this.selectedSections.includes(section.name));
        const query = this.normalizeSearch(this.searchText);
        const isSearching = !!query;
        let total = 0;
        let direct = 0;
        let similar = 0;

        const sections = sourceSections.map((section) => {
            const songs = (section.songs || [])
                .map((song: any) => {
                    if (!isSearching) return song;
                    const match = this.scoreSongSearch(song, section, query);
                    if (!match.matched) return null;
                    total++;
                    if (match.type === 'direct') direct++;
                    else similar++;
                    return {
                        ...song,
                        searchScore: match.score,
                        searchType: match.type
                    };
                })
                .filter((song: any) => !!song);

            return {
                ...section,
                songs: this.sortSectionSongs(songs)
            };
        });

        this.sections = isSearching ? sections.filter((section) => section.songs.length > 0) : sections;
        this.searchSummary = { query: this.searchText.trim(), total, direct, similar };
    }

    private sortSectionSongs(songs: any[]): any[] {
        const source = Array.isArray(songs) ? songs : [];
        if (this.hasSearchQuery()) {
            return source
                .map((song, index) => ({ song, index }))
                .sort((left, right) => {
                    const scoreDiff = (Number(right.song.searchScore) || 0) - (Number(left.song.searchScore) || 0);
                    if (Math.abs(scoreDiff) > 0.0001) return scoreDiff;
                    return left.index - right.index;
                })
                .map((item) => item.song);
        }

        if (this.isRivalSortMode()) {
            if (!this.hasRivalComparison()) return source;
            return source
                .map((song, index) => ({ song, index }))
                .sort((left, right) => {
                    const slot = this.getActiveRivalSlot();
                    const leftDiff = this.getRivalScoreDiff(left.song.songNo, left.song.difficulty, slot);
                    const rightDiff = this.getRivalScoreDiff(right.song.songNo, right.song.difficulty, slot);
                    if (leftDiff !== rightDiff) return leftDiff - rightDiff;

                    const leftKnown = this.shouldShowRivalComparison(left.song.songNo, left.song.difficulty, slot) ? 1 : 0;
                    const rightKnown = this.shouldShowRivalComparison(right.song.songNo, right.song.difficulty, slot) ? 1 : 0;
                    if (leftKnown !== rightKnown) return rightKnown - leftKnown;

                    const leftRivalScore = this.getRivalSongScore(left.song.songNo, left.song.difficulty, slot);
                    const rightRivalScore = this.getRivalSongScore(right.song.songNo, right.song.difficulty, slot);
                    if (leftRivalScore !== rightRivalScore) return rightRivalScore - leftRivalScore;

                    return left.index - right.index;
                })
                .map((item) => item.song);
        }

        if (this.sortMode === 'clear' || this.sortMode === 'score') {
            return source
                .map((song, index) => ({ song, index }))
                .sort((left, right) => {
                    const leftCrown = this.getCrownRank(this.getSongCrown(left.song.songNo, left.song.difficulty));
                    const rightCrown = this.getCrownRank(this.getSongCrown(right.song.songNo, right.song.difficulty));
                    const leftScore = this.getSongScore(left.song.songNo, left.song.difficulty);
                    const rightScore = this.getSongScore(right.song.songNo, right.song.difficulty);

                    if (this.sortMode === 'clear') {
                        const crownDiff = rightCrown - leftCrown;
                        if (crownDiff !== 0) return crownDiff;

                        const scoreDiff = rightScore - leftScore;
                        if (scoreDiff !== 0) return scoreDiff;
                    }

                    if (this.sortMode === 'score') {
                        const scoreDiff = rightScore - leftScore;
                        if (scoreDiff !== 0) return scoreDiff;

                        const crownDiff = rightCrown - leftCrown;
                        if (crownDiff !== 0) return crownDiff;
                    }

                    return left.index - right.index;
                })
                .map((item) => item.song);
        }

        return source;
    }

    public hasSearchQuery(): boolean {
        return !!this.normalizeSearch(this.searchText);
    }

    public onSearchInput() {
        this.applySectionFilters();
        this.updateLevelStats();
        this.service.render();
    }

    public clearSearch(event?: Event) {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        if (!this.searchText) return;
        this.searchText = '';
        this.applySectionFilters();
        this.updateLevelStats();
        this.service.render();
    }

    public onSearchKeydown(event: KeyboardEvent) {
        if (event.key !== 'Escape') return;
        this.clearSearch(event);
    }

    private normalizeSearch(value: any): string {
        return String(value || '')
            .normalize('NFKC')
            .toLowerCase()
            .replace(/[’'`´]/g, '')
            .replace(/[‐‑‒–—―]/g, '-')
            .replace(/\s+/g, ' ')
            .trim();
    }

    private compactSearch(value: any): string {
        return this.normalizeSearch(value).replace(/[^0-9a-z가-힣ぁ-んァ-ヶー一-龥々〆〤]+/gi, '');
    }

    private uniqueStrings(values: string[]): string[] {
        const seen: any = {};
        const result: string[] = [];
        for (const value of values) {
            const normalized = this.normalizeSearch(value);
            if (!normalized || seen[normalized]) continue;
            seen[normalized] = true;
            result.push(normalized);
        }
        return result;
    }

    private getSearchTokens(value: any): string[] {
        return this.uniqueStrings(
            this.normalizeSearch(value)
                .split(/[^0-9a-z가-힣ぁ-んァ-ヶー一-龥々〆〤]+/i)
                .filter((token) => token.length > 0)
        );
    }

    private getSearchTerms(query: string): string[] {
        const normalized = this.normalizeSearch(query);
        const compacted = this.compactSearch(normalized);
        const terms = new Set<string>([normalized, compacted, ...this.getSearchTokens(normalized)]);
        const expansions = [
            ['남코', 'namco', '남코오리지널', '나무코'],
            ['보컬로이드', '보카로', '보컬', 'vocaloid'],
            ['애니', '애니메이션', 'anime'],
            ['게임', 'game'],
            ['클래식', 'classic'],
            ['버라이어티', 'variety'],
            ['팝스', 'pops', 'pop'],
            ['키즈', 'kids'],
            ['앞보면', '오니', 'oni'],
            ['뒷보면', '우라', 'ura'],
            ['최하급', '하급', '중하급', '중급', '중상급', '상급', '최상급', '졸업', '개인차']
        ];

        for (const group of expansions) {
            const normalizedGroup = group.map((term) => this.normalizeSearch(term));
            if (!normalizedGroup.some((term) => normalized.includes(term) || compacted.includes(this.compactSearch(term)))) continue;
            normalizedGroup.forEach((term) => terms.add(term));
        }

        return this.uniqueStrings(Array.from(terms));
    }

    private getSongSearchFields(song: any, section: any): string[] {
        const info = this.songs[song.songNo] || {};
        const genres = Array.isArray(info.genres) ? info.genres : [];
        const genreFields: string[] = [];
        for (const genre of genres) {
            genreFields.push(genre, this.genreLabels[genre] || '');
        }

        const difficultyFields = song.difficulty === 'ura'
            ? ['ura', '우라', '뒷보면']
            : ['oni', '오니', '앞보면'];

        return [
            song.songNo,
            song.title,
            song.difficulty,
            info.title,
            info.titleKo,
            info.aliasKo,
            section?.name,
            this.getSectionDisplayName(section?.name),
            String(this.currentLevel),
            ...difficultyFields,
            ...genreFields
        ].filter((value) => value !== null && value !== undefined && String(value).trim().length > 0);
    }

    private getCharacterNgrams(value: string, size: number): string[] {
        const compacted = this.compactSearch(value);
        if (!compacted) return [];
        if (compacted.length <= size) return [compacted];
        const grams: string[] = [];
        for (let i = 0; i <= compacted.length - size; i++) {
            grams.push(compacted.slice(i, i + size));
        }
        return grams;
    }

    private diceSimilarity(left: string, right: string): number {
        const leftCompact = this.compactSearch(left);
        const rightCompact = this.compactSearch(right);
        if (!leftCompact || !rightCompact) return 0;
        if (leftCompact === rightCompact) return 1;
        if (leftCompact.includes(rightCompact) || rightCompact.includes(leftCompact)) {
            return Math.min(leftCompact.length, rightCompact.length) / Math.max(leftCompact.length, rightCompact.length);
        }

        const size = Math.min(leftCompact.length, rightCompact.length) <= 3 ? 1 : 2;
        const leftGrams = this.getCharacterNgrams(leftCompact, size);
        const rightGrams = this.getCharacterNgrams(rightCompact, size);
        if (!leftGrams.length || !rightGrams.length) return 0;

        const counts: any = {};
        for (const gram of leftGrams) counts[gram] = (counts[gram] || 0) + 1;
        let overlap = 0;
        for (const gram of rightGrams) {
            if (!counts[gram]) continue;
            counts[gram]--;
            overlap++;
        }
        return (2 * overlap) / (leftGrams.length + rightGrams.length);
    }

    private levenshteinSimilarity(left: string, right: string): number {
        const a = this.compactSearch(left);
        const b = this.compactSearch(right);
        if (!a || !b) return 0;
        if (a === b) return 1;
        if (Math.max(a.length, b.length) > 32) return 0;

        const previous: number[] = [];
        const current: number[] = [];
        for (let j = 0; j <= b.length; j++) previous[j] = j;

        for (let i = 1; i <= a.length; i++) {
            current[0] = i;
            for (let j = 1; j <= b.length; j++) {
                const cost = a[i - 1] === b[j - 1] ? 0 : 1;
                current[j] = Math.min(
                    current[j - 1] + 1,
                    previous[j] + 1,
                    previous[j - 1] + cost
                );
            }
            for (let j = 0; j <= b.length; j++) previous[j] = current[j];
        }

        const distance = previous[b.length];
        return 1 - (distance / Math.max(a.length, b.length));
    }

    private tokenSimilarity(query: string, fields: string[]): number {
        const queryTokens = this.getSearchTokens(query).filter((token) => token.length >= 2);
        if (!queryTokens.length) return 0;
        const fieldTokens = new Set(this.getSearchTokens(fields.join(' ')));
        if (!fieldTokens.size) return 0;

        let matched = 0;
        for (const token of queryTokens) {
            if (fieldTokens.has(token)) matched++;
        }
        return matched / queryTokens.length;
    }

    private scoreSongSearch(song: any, section: any, query: string) {
        if (!query) return { matched: true, type: 'direct', score: 1 };

        const terms = this.getSearchTerms(query);
        const fields = this.getSongSearchFields(song, section);
        const haystack = this.normalizeSearch(fields.join(' '));
        const compactHaystack = this.compactSearch(fields.join(' '));
        const queryCompact = this.compactSearch(query);

        let directScore = 0;
        if ((query.length >= 1 && haystack.includes(query)) || (queryCompact.length >= 1 && compactHaystack.includes(queryCompact))) {
            directScore = 1;
        }

        for (const term of terms) {
            const compactTerm = this.compactSearch(term);
            if (compactTerm.length < 2) continue;
            if (haystack.includes(term) || compactHaystack.includes(compactTerm)) {
                directScore = Math.max(directScore, compactTerm === queryCompact ? 1 : 0.82);
            }
        }

        const queryTokens = this.getSearchTokens(query).filter((token) => token.length >= 2);
        if (queryTokens.length > 1 && queryTokens.every((token) => compactHaystack.includes(this.compactSearch(token)))) {
            directScore = Math.max(directScore, 0.9);
        }

        if (directScore > 0) {
            return {
                matched: true,
                type: 'direct',
                score: Math.min(1.25, directScore + Math.min(queryCompact.length / 40, 0.18))
            };
        }

        const titleFields = fields.slice(0, 6);
        let similarScore = this.tokenSimilarity(query, fields) * 0.72;
        for (const field of titleFields) {
            similarScore = Math.max(
                similarScore,
                this.diceSimilarity(query, field),
                this.levenshteinSimilarity(query, field) * 0.95
            );
        }

        if (similarScore >= this.similarSearchThreshold) {
            return { matched: true, type: 'similar', score: similarScore };
        }

        return { matched: false, type: 'none', score: 0 };
    }

    public getSortModeLabel(): string {
        if (this.isRivalSortMode()) {
            const slot = this.getActiveRivalSlot();
            return `정렬: 라이벌 ${slot} ${this.getRivalDisplayName(slot)}`;
        }
        if (this.sortMode === 'clear') return '정렬: 클리어순';
        if (this.sortMode === 'score') return '정렬: 스코어순';
        return '정렬: 티어순';
    }

    private getNextSortMode(): SortMode {
        const index = this.sortModeOrder.indexOf(this.sortMode);
        return this.sortModeOrder[(index + 1) % this.sortModeOrder.length];
    }

    public getSortToggleAriaLabel(): string {
        const nextMode = this.getNextSortMode();
        const nextLabel = nextMode === 'clear'
            ? '클리어순'
            : nextMode === 'score'
                ? '스코어순'
                : this.isRivalSortMode(nextMode)
                    ? `라이벌 ${this.getRivalSlotFromMode(nextMode)} 점수차순`
                    : '티어순';
        return `정렬 변경: 다음은 ${nextLabel}`;
    }

    public cycleSortMode() {
        this.sortMode = this.getNextSortMode();
        this.rivalScores = this.getRivalScoresForSlot(this.getActiveRivalSlot());
        this.applySectionFilters();
        this.updateLevelStats();
        this.service.render();
    }

    public showTitleTooltip(title: any, event: any) {
        const text = String(title || '').trim();
        if (!text || !event || !event.currentTarget) return;

        const rect = event.currentTarget.getBoundingClientRect();
        const maxWidth = Math.min(420, Math.max(180, window.innerWidth - 16));
        const minLeft = (maxWidth / 2) + 8;
        const maxLeft = window.innerWidth - minLeft;
        const center = rect.left + rect.width / 2;
        const placement = rect.top < 64 ? 'below' : 'above';
        this.titleTooltip = {
            visible: true,
            text,
            left: Math.min(Math.max(center, minLeft), maxLeft),
            top: placement === 'below' ? rect.bottom + 8 : rect.top - 8,
            placement
        };
        this.service.render();
    }

    public hideTitleTooltip() {
        if (!this.titleTooltip.visible) return;
        this.titleTooltip = { visible: false, text: '', left: 0, top: 0, placement: 'above' };
        this.service.render();
    }

    private calculateSectionStats(sections: any[]) {
        let total = 0, played = 0, clear = 0, fc = 0, dfc = 0;
        for (const section of sections || []) {
            for (const song of section.songs || []) {
                total++;
                const crown = this.getSongCrown(song.songNo, song.difficulty);
                if (crown === 'played') played++;
                else if (crown === 'clear') clear++;
                else if (crown === 'fc') fc++;
                else if (crown === 'dfc') dfc++;
            }
        }
        return { total, played, clear, fc, dfc };
    }

    public updateLevelStats() {
        this.levelStats = this.calculateSectionStats(this.sections);
    }

    public getStatPercent(count: number): string {
        if (!this.levelStats.total) return '0%';
        return ((count / this.levelStats.total) * 100).toFixed(1) + '%';
    }

    public selectLevel(level: number) {
        this.service.href(`/taiko/${level}`);
    }

    public selectDanMode() {
        this.service.href('/taiko/dan');
    }

    public isDanModeSelected(): boolean {
        return this.viewMode === 'dan';
    }

    public isLevelSelected(level: number): boolean {
        return this.viewMode === 'level' && this.currentLevel === level;
    }

    public isSectionFilterSelected(name: string): boolean {
        return name === 'all' ? this.selectedSections.length === 0 : this.selectedSections.includes(name);
    }

    public toggleSectionFilter(name: string, event?: Event) {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }

        if (name === 'all') {
            this.selectedSections = [];
        } else {
            this.selectedSections = this.selectedSections.includes(name)
                ? this.selectedSections.filter((sectionName) => sectionName !== name)
                : [...this.selectedSections, name];
        }

        this.applySectionFilters();
        this.updateLevelStats();
        this.updateWeeklyRecommendations();
        this.service.render();
    }

    public getSongKey(songNo: string, difficulty: string): string {
        return `${songNo}_${difficulty}`;
    }

    private getSongRecord(songNo: string, difficulty: string): any {
        const key = this.getSongKey(songNo, difficulty);
        const value = this.songData[key];
        if (!value) return { crown: 'none', score: 0 };
        if (typeof value === 'string') return { crown: value, score: 0 };
        return value;
    }

    public getSongCrown(songNo: string, difficulty: string): string {
        return this.getSongRecord(songNo, difficulty)?.crown || 'none';
    }

    public getSongScore(songNo: string, difficulty: string): number {
        return this.normalizeRecordScore(this.getSongRecord(songNo, difficulty)?.score);
    }

    private isRivalSortMode(mode: SortMode = this.sortMode): boolean {
        return mode === 'rival1' || mode === 'rival2' || mode === 'rival3';
    }

    private getRivalSlotFromMode(mode: SortMode = this.sortMode): number {
        if (mode === 'rival2') return 2;
        if (mode === 'rival3') return 3;
        return 1;
    }

    public getActiveRivalSlot(): number {
        return this.getRivalSlotFromMode(this.sortMode);
    }

    private getRivalInfoForSlot(slot: number = this.getActiveRivalSlot()): any {
        const rivals = Array.isArray(this.rivalInfo?.rivals) ? this.rivalInfo.rivals : [];
        return rivals.find((item: any) => Number(item?.slot) === slot) || null;
    }

    private getRivalScoresForSlot(slot: number = this.getActiveRivalSlot()): any {
        return this.rivalScoresBySlot?.[slot] || {};
    }

    private getRivalSongRecord(songNo: string, difficulty: string, slot: number = this.getActiveRivalSlot()): any {
        const key = this.getSongKey(songNo, difficulty);
        const value = this.getRivalScoresForSlot(slot)[key];
        if (!value) return { crown: 'none', score: 0 };
        if (typeof value === 'string') return { crown: value, score: 0 };
        return value;
    }

    public getRivalSongScore(songNo: string, difficulty: string, slot: number = this.getActiveRivalSlot()): number {
        return this.normalizeRecordScore(this.getRivalSongRecord(songNo, difficulty, slot)?.score);
    }

    public hasRivalComparison(slot: number = this.getActiveRivalSlot()): boolean {
        const rival = this.getRivalInfoForSlot(slot);
        return !!(rival && rival.resolved);
    }

    public shouldShowRivalComparison(songNo: string, difficulty: string, slot: number = this.getActiveRivalSlot()): boolean {
        if (!this.hasRivalComparison(slot)) return false;
        return this.getSongScore(songNo, difficulty) > 0 || this.getRivalSongScore(songNo, difficulty, slot) > 0;
    }

    public getRivalDisplayName(slot: number = this.getActiveRivalSlot()): string {
        if (this.rivalLoading) return '불러오는 중';
        const rival = this.getRivalInfoForSlot(slot);
        if (rival?.rival?.name) return rival.rival.name;
        if (rival?.rival?.publicId) return rival.rival.publicId;
        if (rival?.rivalId) return rival.rivalId;
        return '없음';
    }

    public getRivalScoreDiff(songNo: string, difficulty: string, slot: number = this.getActiveRivalSlot()): number {
        return this.getSongScore(songNo, difficulty) - this.getRivalSongScore(songNo, difficulty, slot);
    }

    public getRivalScoreDiffLabel(songNo: string, difficulty: string, slot: number = this.getActiveRivalSlot()): string {
        const diff = this.getRivalScoreDiff(songNo, difficulty, slot);
        const prefix = diff >= 0 ? '+' : '-';
        return `${prefix}${Math.abs(diff)}`;
    }

    public getRivalDiffClass(songNo: string, difficulty: string, slot: number = this.getActiveRivalSlot()): string {
        const diff = this.getRivalScoreDiff(songNo, difficulty, slot);
        if (diff > 0) return 'is-win';
        if (diff < 0) return 'is-lose';
        return 'is-even';
    }

    public getCrownInfo(crown: string) {
        return this.crownList.find(c => c.key === crown) || this.crownList[0];
    }

    public getCrownFill(songNo: string, difficulty: string): string {
        const crown = this.getSongCrown(songNo, difficulty);
        const info = this.getCrownInfo(crown);
        return info.color;
    }

    public isRainbowCrown(songNo: string, difficulty: string): boolean {
        return this.getSongCrown(songNo, difficulty) === 'dfc';
    }

    public toggleStatus(songNo: string, difficulty: string, event: Event) {
        event.stopPropagation();
        event.preventDefault();
        const key = this.getSongKey(songNo, difficulty);
        const current = this.songData[key]?.crown || 'none';
        const idx = this.crownOrder.indexOf(current);
        const next = this.crownOrder[(idx + 1) % this.crownOrder.length];
        if (!this.songData[key]) this.songData[key] = { crown: 'none', score: 0 };
        this.songData[key].crown = next;
        this.applySectionFilters();
        this.updateLevelStats();
        this.updateWeeklyRecommendations();
        this.saveSongData();
        this.service.render();
    }

    public reverseStatus(songNo: string, difficulty: string, event: Event) {
        event.stopPropagation();
        event.preventDefault();
        const key = this.getSongKey(songNo, difficulty);
        const current = this.songData[key]?.crown || 'none';
        const idx = this.crownOrder.indexOf(current);
        const prev = this.crownOrder[(idx - 1 + this.crownOrder.length) % this.crownOrder.length];
        if (!this.songData[key]) this.songData[key] = { crown: 'none', score: 0 };
        this.songData[key].crown = prev;
        this.applySectionFilters();
        this.updateLevelStats();
        this.updateWeeklyRecommendations();
        this.saveSongData();
        this.service.render();
    }

    public getCardBgClass(songNo: string, difficulty: string): string {
        const crown = this.getSongCrown(songNo, difficulty);
        if (this.themeMode === 'light') {
            switch (crown) {
                case 'played': return 'bg-white';
                case 'clear': return 'bg-white';
                case 'fc': return 'bg-white';
                case 'dfc': return 'bg-white';
                default: return 'bg-white hover:bg-zinc-100';
            }
        }
        switch (crown) {
            case 'played': return 'bg-orange-950/30';
            case 'clear': return 'bg-zinc-700/30';
            case 'fc': return 'bg-yellow-950/30';
            case 'dfc': return 'bg-indigo-950/30';
            default: return 'bg-zinc-900 hover:bg-zinc-800';
        }
    }

    public getScoreColor(score: number): string {
        if (!score || score <= 0) return '#4B5563';
        for (const rank of this.scoreRanks) {
            if (score >= rank.min) return rank.color === 'rainbow' ? '' : rank.color;
        }
        return '#4B5563';
    }

    public isRainbowScore(score: number): boolean {
        return score >= 1000000;
    }

    public formatScore(score: number): string {
        if (!score || score <= 0) return '';
        return score.toLocaleString();
    }

    private clamp(value: number, min: number, max: number): number {
        return Math.max(min, Math.min(max, value));
    }

    private clampPercent(value: number): number {
        return Math.round(this.clamp(value, 0, 100));
    }

    private parseTaikoDanNumbers(value: any): number[] {
        const text = String(value || '');
        const matches = text.match(/\d+(?:,\d{3})*(?:\.\d+)?|\d+/g) || [];
        return matches
            .map((item) => Number(item.replace(/,/g, '')))
            .filter((item) => Number.isFinite(item));
    }

    private findTaikoDanRequirement(course: any, kind: 'good' | 'ok' | 'miss' | 'roll' | 'gauge'): any {
        const requirements = Array.isArray(course?.criteria?.requirements) ? course.criteria.requirements : [];
        return requirements.find((requirement: any) => {
            const type = String(requirement?.type || '').replace(/\s+/g, '');
            if (kind === 'good') return type.includes('량');
            if (kind === 'ok') return type.startsWith('가');
            if (kind === 'miss') return type.includes('불가');
            if (kind === 'roll') return type.includes('연타');
            if (kind === 'gauge') return type.includes('혼') || type.includes('게이지');
            return false;
        });
    }

    private getTaikoDanRequirementNumbers(course: any, kind: 'good' | 'ok' | 'miss' | 'roll' | 'gauge'): number[] {
        const requirement = this.findTaikoDanRequirement(course, kind);
        return this.parseTaikoDanNumbers(requirement?.red);
    }

    private getTaikoDanSongEstimate(song: any) {
        const maxCombo = Math.max(0, Number(song?.maxCombo || 0));
        const record = this.getTaikoDanSongRecord(song);
        const crown = String(record.crown || 'none');
        const score = this.normalizeRecordScore(record.score);
        const recordRoll = this.normalizeRecordCount(record.roll);
        const hasJudgementStats = !!record.hasJudgementStats;
        const hasRollStats = !!record.hasRollStats;
        const hasRecord = crown !== 'none' || score > 0 || hasJudgementStats || hasRollStats;

        if (maxCombo <= 0 || !hasJudgementStats) {
            return {
                maxCombo,
                score,
                crown,
                hasRecord,
                hasScore: score > 0,
                exact: false,
                good: 0,
                ok: 0,
                miss: 0,
                roll: recordRoll,
                hasRoll: hasRollStats,
                hasJudgementStats,
                goodEquivalent: 0,
                minGood: 0,
                maxGood: 0,
                minOk: 0,
                maxOk: 0,
                minMiss: 0,
                maxMiss: 0
            };
        }

        const good = this.clamp(this.normalizeRecordCount(record.good), 0, maxCombo);
        const ok = this.clamp(this.normalizeRecordCount(record.ok), 0, maxCombo);
        const miss = this.clamp(this.normalizeRecordCount(record.bad), 0, maxCombo);

        return {
            maxCombo,
            score,
            crown,
            hasRecord: true,
            hasScore: score > 0,
            exact: true,
            good,
            ok,
            miss,
            roll: recordRoll,
            hasRoll: hasRollStats,
            hasJudgementStats: true,
            goodEquivalent: good + ok / 2,
            minGood: good,
            maxGood: good,
            minOk: ok,
            maxOk: ok,
            minMiss: miss,
            maxMiss: miss
        };
    }

    private getTaikoDanChanceFromMinimum(value: number, minValue: number, scale: number): number {
        return this.clampPercent(50 + ((value - minValue) / Math.max(1, scale)) * 50);
    }

    private getTaikoDanChanceFromMaximum(value: number, maxValue: number, scale: number): number {
        return this.clampPercent(50 + ((maxValue - value) / Math.max(1, scale)) * 50);
    }

    public getTaikoDanRequiredCrown(course: any): string {
        return String(course?.criteria?.requiredCrown || 'clear');
    }

    public getTaikoDanMinimumScore(course: any): number {
        return Math.max(0, Number(course?.criteria?.minimumScore || 0));
    }

    public getTaikoDanCriteriaText(course: any): string {
        const text = String(course?.criteria?.description || '').trim();
        if (text) return text;
        const minimumScore = this.getTaikoDanMinimumScore(course);
        return minimumScore > 0
            ? `과제곡 모두 클리어 이상, 각 곡 ${this.formatScore(minimumScore)}점 이상`
            : '과제곡 모두 클리어 이상';
    }

    public getTaikoDanJudgeNote(course: any): string {
        return String(course?.criteria?.judgeNote || '').trim();
    }

    public getTaikoDanSongTitle(song: any): string {
        return this.getOriginalTitle(song) || `곡 번호 ${song?.songNo || '-'}`;
    }

    public getTaikoDanSongSubtitle(song: any): string {
        const translated = this.getTranslatedTitle(song);
        const parts: string[] = [];
        if (translated && translated !== this.getTaikoDanSongTitle(song)) parts.push(translated);
        if (song?.level) parts.push(`★${song.level}`);
        if (song?.maxCombo) parts.push(`${song.maxCombo}콤보`);
        return parts.join(' · ');
    }

    public getTaikoDanSongRecord(song: any): any {
        const record = this.getSongRecord(song?.songNo, song?.difficulty);
        const good = this.getRecordCount(record, 'good', 'goodCount', 'good_count', 'ryo', '良', '량');
        const ok = this.getRecordCount(record, 'ok', 'okCount', 'ok_count', 'ka', '可', '가');
        const bad = this.getRecordCount(record, 'bad', 'badCount', 'bad_count', 'ng', '不可', '불가');
        const maxCombo = this.getRecordCount(record, 'maxCombo', 'max_combo', 'combo', 'comboCount', 'combo_count');
        const roll = this.getRecordCount(record, 'roll', 'drumroll', 'drumRoll', 'drumrollCount', 'pound', 'poundCount', 'pound_count', 'renda');
        return {
            crown: record?.crown || 'none',
            score: this.normalizeRecordScore(record?.score),
            good,
            ok,
            bad,
            maxCombo,
            roll,
            hasJudgementStats: good + ok + bad > 0,
            hasRollStats: roll > 0
        };
    }

    public isTaikoDanSongSatisfied(course: any, song: any): boolean {
        const record = this.getTaikoDanSongRecord(song);
        const crownOk = this.getCrownRank(record.crown) >= this.getCrownRank(this.getTaikoDanRequiredCrown(course));
        const minimumScore = this.getTaikoDanMinimumScore(course);
        const scoreOk = minimumScore <= 0 || Number(record.score || 0) >= minimumScore;
        return crownOk && scoreOk;
    }

    private formatTaikoDanNumber(value: number): string {
        return Math.max(0, Math.floor(Number(value || 0))).toLocaleString();
    }

    private formatTaikoDanNumberList(values: number[]): string {
        return values.map((value) => this.formatTaikoDanNumber(value)).join(' / ');
    }

    private buildTaikoDanMinMetric(key: string, label: string, value: number, target: number, available: boolean) {
        const safeTarget = Math.max(0, Number(target || 0));
        const safeValue = Math.max(0, Number(value || 0));
        const passed = available && (safeTarget <= 0 || safeValue >= safeTarget);
        return {
            key,
            label,
            mode: 'min',
            available,
            passed,
            value: safeValue,
            target: safeTarget,
            currentLabel: this.formatTaikoDanNumber(safeValue),
            targetLabel: `${this.formatTaikoDanNumber(safeTarget)} 이상`,
            percent: safeTarget > 0 ? this.clampPercent((safeValue / safeTarget) * 100) : 100,
            readinessPercent: safeTarget > 0 ? this.clampPercent((safeValue / safeTarget) * 100) : 100,
            note: available ? (passed ? '기준 통과' : '기준 미달') : '상세 기록 필요'
        };
    }

    private buildTaikoDanMaxExclusiveMetric(key: string, label: string, value: number, targetExclusive: number, available: boolean) {
        const safeTarget = Math.max(0, Number(targetExclusive || 0));
        const safeValue = Math.max(0, Number(value || 0));
        const passed = available && safeValue < safeTarget;
        return {
            key,
            label,
            mode: 'max',
            available,
            passed,
            value: safeValue,
            target: safeTarget,
            currentLabel: this.formatTaikoDanNumber(safeValue),
            targetLabel: `${this.formatTaikoDanNumber(safeTarget)} 미만`,
            percent: safeTarget > 0 ? this.clampPercent((safeValue / safeTarget) * 100) : (safeValue > 0 ? 100 : 0),
            readinessPercent: !available ? 0 : passed ? 100 : this.clampPercent((safeTarget / Math.max(1, safeValue)) * 100),
            note: available ? (passed ? '기준 통과' : '기준 초과') : '상세 기록 필요'
        };
    }

    private buildTaikoDanPerSongMinMetric(key: string, label: string, values: number[], targets: number[], available: boolean) {
        const safeTargets = targets.map((value) => Math.max(0, Number(value || 0)));
        const safeValues = values.map((value) => Math.max(0, Number(value || 0)));
        const passed = available && safeTargets.every((target, index) => target <= 0 || safeValues[index] >= target);
        const ratios = safeTargets.map((target, index) => target > 0 ? safeValues[index] / target : 1);
        const progress = ratios.length > 0 ? Math.min(...ratios) : 1;
        return {
            key,
            label,
            mode: 'min',
            available,
            passed,
            values: safeValues,
            targets: safeTargets,
            currentLabel: this.formatTaikoDanNumberList(safeValues),
            targetLabel: `${this.formatTaikoDanNumberList(safeTargets)} 이상`,
            percent: this.clampPercent(progress * 100),
            readinessPercent: this.clampPercent(progress * 100),
            note: available ? (passed ? '기준 통과' : '기준 미달') : '상세 기록 필요'
        };
    }

    private buildTaikoDanPerSongMaxExclusiveMetric(key: string, label: string, values: number[], targets: number[], available: boolean) {
        const safeTargets = targets.map((value) => Math.max(0, Number(value || 0)));
        const safeValues = values.map((value) => Math.max(0, Number(value || 0)));
        const passed = available && safeTargets.every((target, index) => safeValues[index] < target);
        const ratios = safeTargets.map((target, index) => target > 0 ? safeValues[index] / target : (safeValues[index] > 0 ? 1 : 0));
        const maxRatio = ratios.length > 0 ? Math.max(...ratios) : 0;
        return {
            key,
            label,
            mode: 'max',
            available,
            passed,
            values: safeValues,
            targets: safeTargets,
            currentLabel: this.formatTaikoDanNumberList(safeValues),
            targetLabel: `${this.formatTaikoDanNumberList(safeTargets)} 미만`,
            percent: this.clampPercent(maxRatio * 100),
            readinessPercent: !available ? 0 : passed ? 100 : this.clampPercent(100 / Math.max(1, maxRatio)),
            note: available ? (passed ? '기준 통과' : '기준 초과') : '상세 기록 필요'
        };
    }

    public getTaikoDanRequirementMetrics(course: any, stats: any = null): any[] {
        const resolvedStats = stats || this.getTaikoDanCourseStats(course);
        const estimates = Array.isArray(resolvedStats?.estimates) ? resolvedStats.estimates : [];
        const metrics: any[] = [];
        const judgementAvailable = !!resolvedStats?.judgementComplete;

        if (resolvedStats?.goodMin !== null && resolvedStats?.goodMin !== undefined) {
            metrics.push(this.buildTaikoDanMinMetric('good', '량', resolvedStats.estimatedGood, resolvedStats.goodMin, judgementAvailable));
        }

        const okNumbers = Array.isArray(resolvedStats?.okNumbers) ? resolvedStats.okNumbers : [];
        if (okNumbers.length > 0) {
            if (okNumbers.length === estimates.length) {
                metrics.push(this.buildTaikoDanPerSongMaxExclusiveMetric(
                    'ok',
                    '가',
                    estimates.map((item: any) => Number(item.ok || 0)),
                    okNumbers,
                    judgementAvailable
                ));
            } else {
                metrics.push(this.buildTaikoDanMaxExclusiveMetric('ok', '가', resolvedStats.estimatedOk, okNumbers[0], judgementAvailable));
            }
        }

        if (resolvedStats?.missMaxExclusive !== null && resolvedStats?.missMaxExclusive !== undefined) {
            metrics.push(this.buildTaikoDanMaxExclusiveMetric(
                'miss',
                '불가',
                resolvedStats.estimatedMiss,
                resolvedStats.missMaxExclusive,
                judgementAvailable
            ));
        }

        const rollNumbers = Array.isArray(resolvedStats?.rollNumbers) ? resolvedStats.rollNumbers : [];
        if (rollNumbers.length > 0) {
            if (rollNumbers.length === estimates.length) {
                const available = estimates.every((item: any, index: number) => Number(rollNumbers[index] || 0) <= 0 || item.hasRoll);
                metrics.push(this.buildTaikoDanPerSongMinMetric(
                    'roll',
                    '연타',
                    estimates.map((item: any) => Number(item.roll || 0)),
                    rollNumbers,
                    available
                ));
            } else {
                const rollMin = Math.max(0, Number(rollNumbers[0] || 0));
                const available = rollMin <= 0 || Number(resolvedStats?.rollRecorded || 0) > 0;
                metrics.push(this.buildTaikoDanMinMetric('roll', '연타', resolvedStats.estimatedRoll, rollMin, available));
            }
        }

        return metrics;
    }

    public getTaikoDanMetricClass(metric: any): string {
        const classes = ['taiko-dan-metric'];
        if (metric?.mode === 'max') classes.push('is-max');
        if (!metric?.available) classes.push('is-missing');
        else if (metric?.passed) classes.push('is-pass');
        else classes.push('is-fail');
        return classes.join(' ');
    }

    public getTaikoDanCourseStats(course: any) {
        const songs = Array.isArray(course?.songs) ? course.songs : [];
        const estimates = songs.map((song: any) => this.getTaikoDanSongEstimate(song));
        const satisfied = songs.filter((song: any) => this.isTaikoDanSongSatisfied(course, song)).length;
        const totalCombo = estimates.reduce((sum: number, item: any) => sum + item.maxCombo, 0);
        const recorded = estimates.filter((item: any) => item.hasRecord).length;
        const scored = estimates.filter((item: any) => item.hasScore).length;
        const exact = estimates.length > 0 && estimates.every((item: any) => item.exact);
        const estimatedGood = estimates.reduce((sum: number, item: any) => sum + item.good, 0);
        const estimatedOk = estimates.reduce((sum: number, item: any) => sum + item.ok, 0);
        const estimatedMiss = estimates.reduce((sum: number, item: any) => sum + item.miss, 0);
        const estimatedRoll = estimates.reduce((sum: number, item: any) => sum + item.roll, 0);
        const estimatedGoodEquivalent = estimates.reduce((sum: number, item: any) => sum + item.goodEquivalent, 0);
        const judgementRecorded = estimates.filter((item: any) => item.hasJudgementStats).length;
        const rollRecorded = estimates.filter((item: any) => item.hasRoll).length;
        const judgementComplete = songs.length > 0 && judgementRecorded === songs.length;
        const minGood = estimates.reduce((sum: number, item: any) => sum + item.minGood, 0);
        const maxGood = estimates.reduce((sum: number, item: any) => sum + item.maxGood, 0);
        const maxOk = estimates.reduce((sum: number, item: any) => sum + item.maxOk, 0);
        const maxMiss = estimates.reduce((sum: number, item: any) => sum + item.maxMiss, 0);
        const goodNumbers = this.getTaikoDanRequirementNumbers(course, 'good');
        const okNumbers = this.getTaikoDanRequirementNumbers(course, 'ok');
        const missNumbers = this.getTaikoDanRequirementNumbers(course, 'miss');
        const rollNumbers = this.getTaikoDanRequirementNumbers(course, 'roll');
        const goodMin = goodNumbers.length > 0 ? goodNumbers[0] : null;
        const missMaxExclusive = missNumbers.length > 0 ? missNumbers[0] : null;
        const missMaxAllowed = missMaxExclusive !== null ? Math.max(0, missMaxExclusive - 1) : null;
        const hasRollRequirement = rollNumbers.length > 0;
        const clearSignal = songs.length > 0
            ? this.clampPercent((satisfied / songs.length) * 100)
            : 0;

        let goodChance: number | null = null;
        if (goodMin !== null && judgementComplete) {
            const scale = Math.max(24, totalCombo * 0.025);
            goodChance = this.getTaikoDanChanceFromMinimum(estimatedGood, goodMin, scale);
            if (minGood >= goodMin) goodChance = 100;
            if (judgementRecorded === songs.length && maxGood < goodMin) goodChance = Math.min(goodChance, 18);
        }

        let okChance: number | null = null;
        let okMaxAllowed: number | null = null;
        let perSongOkMaxAllowed: number[] = [];
        if (okNumbers.length > 0 && judgementComplete) {
            const scale = Math.max(8, totalCombo * 0.018);
            if (okNumbers.length === estimates.length) {
                perSongOkMaxAllowed = okNumbers.map((value) => Math.max(0, value - 1));
                const chances = estimates.map((item: any, index: number) => {
                    const allowed = perSongOkMaxAllowed[index];
                    let chance = this.getTaikoDanChanceFromMaximum(item.ok, allowed, Math.max(4, item.maxCombo * 0.025));
                    if (item.maxOk <= allowed && item.hasJudgementStats) chance = 100;
                    if (item.hasJudgementStats && item.minOk > allowed) chance = Math.min(chance, 18);
                    return chance;
                });
                okChance = chances.length > 0 ? Math.min(...chances) : 0;
            } else {
                okMaxAllowed = Math.max(0, okNumbers[0] - 1);
                okChance = this.getTaikoDanChanceFromMaximum(estimatedOk, okMaxAllowed, scale);
                if (maxOk <= okMaxAllowed) okChance = 100;
            }
        }

        let missChance: number | null = null;
        if (missMaxAllowed !== null && judgementComplete) {
            const scale = Math.max(3, totalCombo * 0.006);
            missChance = this.getTaikoDanChanceFromMaximum(estimatedMiss, missMaxAllowed, scale);
            if (maxMiss <= missMaxAllowed) missChance = 100;
        }

        let rollChance: number | null = null;
        let rollMin: number | null = null;
        let perSongRollMin: number[] = [];
        if (hasRollRequirement) {
            if (rollNumbers.length === estimates.length) {
                perSongRollMin = rollNumbers.map((value) => Math.max(0, value));
                if (estimates.every((item: any, index: number) => perSongRollMin[index] <= 0 || item.hasRoll)) {
                    const chances = estimates.map((item: any, index: number) => {
                        const required = perSongRollMin[index];
                        if (required <= 0) return 100;
                        return this.getTaikoDanChanceFromMinimum(item.roll, required, Math.max(3, required * 0.12));
                    });
                    rollChance = chances.length > 0 ? Math.min(...chances) : 0;
                }
            } else {
                rollMin = Math.max(0, rollNumbers[0]);
                if (rollMin <= 0 || rollRecorded > 0) {
                    rollChance = this.getTaikoDanChanceFromMinimum(estimatedRoll, rollMin, Math.max(5, rollMin * 0.12));
                }
            }
        }

        const stats: any = {
            total: songs.length,
            satisfied,
            remaining: Math.max(0, songs.length - satisfied),
            passed: songs.length > 0 && satisfied === songs.length,
            recorded,
            scored,
            totalCombo,
            estimates,
            exact,
            estimatedGood,
            estimatedOk,
            estimatedMiss,
            estimatedRoll,
            estimatedGoodEquivalent,
            judgementRecorded,
            rollRecorded,
            judgementComplete,
            minGood,
            maxGood,
            maxOk,
            maxMiss,
            goodMin,
            okNumbers,
            okMaxAllowed,
            perSongOkMaxAllowed,
            missMaxExclusive,
            missMaxAllowed,
            rollNumbers,
            hasRollRequirement,
            probability: 0,
            goodChance,
            okChance,
            missChance,
            rollChance,
            rollMin,
            perSongRollMin,
            analysisAvailable: false,
            criteriaPassed: false
        };

        const metrics = this.getTaikoDanRequirementMetrics(course, stats);
        const requiredSignals = metrics.map((metric: any) => Number(metric.readinessPercent || 0));
        const hasMissingMetric = metrics.some((metric: any) => !metric.available);
        stats.requirementMetrics = metrics;
        stats.analysisAvailable = metrics.length === 0 || !hasMissingMetric;
        stats.criteriaPassed = stats.analysisAvailable && stats.passed && metrics.every((metric: any) => metric.passed);
        stats.probability = stats.analysisAvailable
            ? this.clampPercent(Math.min(clearSignal, ...(requiredSignals.length ? requiredSignals : [100])))
            : 0;
        return stats;
    }

    public getTaikoDanStatusLabel(course: any): string {
        const stats = this.getTaikoDanCourseStats(course);
        if (stats.recorded <= 0) return '기록 없음';
        if (!stats.analysisAvailable) return '상세 기록 필요';
        if (stats.criteriaPassed) return '기준 통과';
        return `기준 ${stats.probability}%`;
    }

    public isTaikoDanLikelyPassed(course: any): boolean {
        return !!this.getTaikoDanCourseStats(course).criteriaPassed;
    }

    public getTaikoDanProbabilityLabelFromStats(stats: any): string {
        if (!stats || stats.recorded <= 0) return '기록 없음';
        if (!stats.analysisAvailable) return '상세 필요';
        return `${stats.probability}%`;
    }

    public getTaikoDanProbabilityToneFromStats(stats: any): string {
        if (!stats || stats.recorded <= 0) return '기록 없음';
        if (!stats.analysisAvailable) return '동더히로바 필요';
        if (stats.criteriaPassed) return '기준 통과';
        const probability = Number(stats.probability || 0);
        if (probability >= 90) return '근접';
        if (probability >= 70) return '보완 필요';
        return '부족';
    }

    public getTaikoDanRequirementSummary(course: any): string {
        const requirements = Array.isArray(course?.criteria?.requirements) ? course.criteria.requirements : [];
        if (!requirements.length) return this.getTaikoDanCriteriaText(course);

        return requirements
            .map((requirement: any) => {
                const type = String(requirement?.type || '').trim();
                const red = String(requirement?.red || '').trim();
                return [type, red].filter((value) => !!value).join(' ');
            })
            .filter((value: string) => !!value)
            .join(' · ');
    }

    public getTaikoDanSongCoreMeta(song: any): string {
        const parts: string[] = [];
        if (song?.level) parts.push(`★${song.level}`);
        if (song?.maxCombo) parts.push(`${song.maxCombo}콤보`);
        return parts.join(' · ');
    }

    public getTaikoDanRecordLabel(song: any): string {
        const record = this.getTaikoDanSongRecord(song);
        const detailParts: string[] = [];
        if (record.hasJudgementStats) {
            detailParts.push(`량 ${this.formatTaikoDanNumber(record.good)}`);
            detailParts.push(`가 ${this.formatTaikoDanNumber(record.ok)}`);
            detailParts.push(`불가 ${this.formatTaikoDanNumber(record.bad)}`);
        }
        if (record.hasRollStats) detailParts.push(`연타 ${this.formatTaikoDanNumber(record.roll)}`);
        if (detailParts.length) return detailParts.join(' · ');
        const crown = this.getCrownInfo(record.crown).label;
        const score = Number(record.score || 0);
        return score > 0 ? `${crown} · ${this.formatScore(score)}` : crown;
    }

    public startScoreEdit(songNo: string, difficulty: string, event: Event) {
        event.stopPropagation();
        event.preventDefault();
        const key = this.getSongKey(songNo, difficulty);
        this.editingScoreKey = key;
        const currentScore = this.songData[key]?.score || 0;
        this.editingScoreValue = currentScore > 0 ? String(currentScore) : '';
        this.service.render();
        setTimeout(() => {
            const inputId = this.getScoreInputId(songNo, difficulty);
            const input = document.getElementById(inputId);
            if (input) (input as HTMLInputElement).focus();
        }, 50);
    }

    public saveScore(songNo: string, difficulty: string) {
        const key = this.getSongKey(songNo, difficulty);
        if (this.editingScoreKey !== key) return;
        const score = parseInt(this.editingScoreValue) || 0;
        if (!this.songData[key]) this.songData[key] = { crown: 'none', score: 0 };
        this.songData[key].score = Math.max(0, Math.min(score, 1200000));
        this.editingScoreKey = '';
        this.editingScoreValue = '';
        this.applySectionFilters();
        this.updateLevelStats();
        this.updateWeeklyRecommendations();
        this.saveSongData();
        this.service.render();
    }

    public cancelScoreEdit() {
        this.editingScoreKey = '';
        this.editingScoreValue = '';
        this.service.render();
    }

    public onScoreKeydown(event: KeyboardEvent, songNo: string, difficulty: string) {
        if (event.key === 'Enter') {
            this.saveScore(songNo, difficulty);
        } else if (event.key === 'Escape') {
            this.cancelScoreEdit();
        }
    }

    public getScoreInputId(songNo: string, difficulty: string): string {
        return 'score-input-' + this.getSongKey(songNo, difficulty).replace(/[^a-zA-Z0-9]/g, '-');
    }

    public getSectionStats(section: any) {
        let total = section.songs.length;
        let played = 0, clear = 0, fc = 0, dfc = 0;
        for (const song of section.songs) {
            const crown = this.getSongCrown(song.songNo, song.difficulty);
            if (crown === 'played') played++;
            else if (crown === 'clear') clear++;
            else if (crown === 'fc') fc++;
            else if (crown === 'dfc') dfc++;
        }
        return { total, cleared: clear + fc + dfc, played, clear, fc, dfc };
    }

    public getLevelStats() {
        let total = 0, cleared = 0, played = 0;
        for (const section of this.sections) {
            for (const song of section.songs) {
                total++;
                const crown = this.getSongCrown(song.songNo, song.difficulty);
                if (crown === 'clear' || crown === 'fc' || crown === 'dfc') cleared++;
                else if (crown === 'played') played++;
            }
        }
        return { total, cleared, played };
    }

    private getWeeklyInfo() {
        const now = new Date();
        const date = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
        const day = date.getUTCDay() || 7;
        date.setUTCDate(date.getUTCDate() + 4 - day);
        const year = date.getUTCFullYear();
        const yearStart = new Date(Date.UTC(year, 0, 1));
        const week = Math.ceil((((date.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
        const weekText = String(week).padStart(2, '0');
        return {
            key: `${year}-W${weekText}`,
            label: `${year}년 ${week}주차`
        };
    }

    private getWeeklyPopularityEntry(scope: string, songKey: string): any {
        if (!scope || !songKey || !this.weeklyPopularity) return {};
        return (this.weeklyPopularity[scope] || {})[songKey] || {};
    }

    private getWeeklyPopularityScore(scope: string, songKey: string): number {
        const entry = this.getWeeklyPopularityEntry(scope, songKey);
        const value = Number(entry.score || 0);
        return this.clamp(value, 0, 1);
    }

    private getWeeklyPopularityCount(scope: string, songKey: string): number {
        const entry = this.getWeeklyPopularityEntry(scope, songKey);
        return Math.max(0, Math.floor(Number(entry.count || 0)));
    }

    private mergeWeeklyPopularityScore(baseScore: number, popularityScore: number): number {
        const weight = 0.18;
        return baseScore * (1 - weight) + popularityScore * weight;
    }

    public getWeeklyPopularityLabel(item: any): string {
        const count = Number(item?.popularityCount || 0);
        if (count <= 1) return '';
        return `추천 ${count}`;
    }

    private async loadWeeklyRecommendations(render: boolean = true, fresh: boolean = false) {
        try {
            const params: any = {
                level: String(this.currentLevel),
                fresh: fresh ? '1' : '0',
                _ts: Date.now()
            };
            if (!this.isLoggedIn) {
                params.data = JSON.stringify(this.songData || {});
            }
            const { code, data } = await wiz.call("load_weekly_recommendations", params);
            if (code === 200 && data) {
                this.weeklyKey = data.weeklyKey || data.weekKey || this.weeklyKey;
                this.weeklyRangeLabel = data.weeklyRangeLabel || data.label || this.weeklyRangeLabel;
                this.weeklyPopularity = data.popularity || {};
                this.updateWeeklyRecommendations();
            }
        } catch { }
        if (render) await this.service.render();
    }

    private hashString(value: string): number {
        let hash = 2166136261;
        for (let i = 0; i < value.length; i++) {
            hash ^= value.charCodeAt(i);
            hash = Math.imul(hash, 16777619);
        }
        return hash >>> 0;
    }

    private seededUnit(value: string): number {
        return this.hashString(value) / 4294967295;
    }

    private getCrownScore(crown: string): number {
        switch (crown) {
            case 'played': return 0.20;
            case 'clear': return 0.55;
            case 'fc': return 0.82;
            case 'dfc': return 1.00;
            default: return 0;
        }
    }

    private getScoreMastery(score: number): number {
        if (!score || score <= 0) return 0;
        if (score >= 1000000) return 1.00;
        if (score >= 950000) return 0.90;
        if (score >= 900000) return 0.78;
        if (score >= 800000) return 0.65;
        if (score >= 700000) return 0.50;
        if (score >= 600000) return 0.35;
        if (score >= 500000) return 0.20;
        return 0.10;
    }

    private getSongMastery(songNo: string, difficulty: string): number {
        const crown = this.getSongCrown(songNo, difficulty);
        const score = this.getSongScore(songNo, difficulty);
        return Math.max(this.getCrownScore(crown), this.getScoreMastery(score) * 0.85);
    }

    private parseBpmValue(value: any): number | null {
        if (typeof value === 'number' && isFinite(value)) return value;
        if (typeof value === 'string') {
            const match = value.match(/\d+(\.\d+)?/);
            if (match) return parseFloat(match[0]);
        }
        return null;
    }

    private getSongBpmInfo(song: any) {
        const info = this.songs[song.songNo] || {};
        const bpm = this.parseBpmValue(info.bpm);
        const bpmMin = this.parseBpmValue(info.bpmMin);
        const bpmMax = this.parseBpmValue(info.bpmMax);
        const bpmType = info.bpmType || '';
        const range = bpmMin !== null && bpmMax !== null ? bpmMax - bpmMin : 0;
        let band = 'unknown';
        const baseBpm = bpm || bpmMax || bpmMin;

        if (bpmType === 'variable' || range >= 40) {
            band = 'variable';
        } else if (baseBpm !== null && baseBpm !== undefined) {
            if (baseBpm <= 120) band = 'slow';
            else if (baseBpm <= 160) band = 'mid';
            else if (baseBpm <= 200) band = 'fast';
            else band = 'very_fast';
        }

        return { bpm: baseBpm, bpmMin, bpmMax, bpmType, band };
    }

    public getBpmBandLabel(band: string): string {
        switch (band) {
            case 'slow': return '저속';
            case 'mid': return '중속';
            case 'fast': return '고속';
            case 'very_fast': return '초고속';
            case 'variable': return '변속';
            default: return '';
        }
    }

    public getBpmBandListLabel(bands: string[]): string {
        if (!Array.isArray(bands)) return '';
        return bands.map((band) => this.getBpmBandLabel(band)).filter((label) => !!label).join(', ');
    }

    public getWeeklyBpmLabel(item: any): string {
        if (!item || !item.bpmBand || item.bpmBand === 'unknown') return '';
        const bandLabel = this.getBpmBandLabel(item.bpmBand);
        if (!item.bpm) return bandLabel;
        return `${bandLabel} ${Math.round(item.bpm)} BPM`;
    }

    private calculateBpmProfile() {
        const stats: any = {};
        let totalPlayed = 0;
        let totalClearable = 0;
        let totalMastery = 0;

        if (!this.allData || !this.allData.levels) return { weak: [], strong: [] };

        for (const level of Object.values(this.allData.levels) as any[]) {
            for (const section of (level.sections || [])) {
                for (const song of (section.songs || [])) {
                    const bpmInfo = this.getSongBpmInfo(song);
                    if (bpmInfo.band === 'unknown') continue;

                    const key = this.getSongKey(song.songNo, song.difficulty);
                    const record = this.songData[key];
                    const score = this.getSongScore(song.songNo, song.difficulty);
                    const crown = this.getSongCrown(song.songNo, song.difficulty);
                    if (!record && !score && crown === 'none') continue;

                    if (!stats[bpmInfo.band]) {
                        stats[bpmInfo.band] = { played: 0, clearable: 0, mastery: 0 };
                    }

                    const mastery = this.getSongMastery(song.songNo, song.difficulty);
                    stats[bpmInfo.band].played++;
                    stats[bpmInfo.band].mastery += mastery;
                    totalPlayed++;
                    totalMastery += mastery;

                    if (crown === 'clear' || crown === 'fc' || crown === 'dfc') {
                        stats[bpmInfo.band].clearable++;
                        totalClearable++;
                    }
                }
            }
        }

        if (totalPlayed < 5) return { weak: [], strong: [] };

        const overallClearRate = totalClearable / totalPlayed;
        const overallMastery = totalMastery / totalPlayed;
        const weak: string[] = [];
        const strong: string[] = [];

        for (const [band, item] of Object.entries(stats) as any[]) {
            if (item.played < 3) continue;
            const clearRate = item.clearable / item.played;
            const mastery = item.mastery / item.played;
            if (clearRate <= overallClearRate - 0.15 && mastery <= overallMastery - 0.10) {
                weak.push(band);
            } else if (clearRate >= overallClearRate + 0.10 && mastery >= overallMastery + 0.08) {
                strong.push(band);
            }
        }

        return { weak, strong };
    }

    private getWeeklyTargetSectionIndex(sections: any[], stats: any): number {
        const last = sections.length - 1;
        if (last <= 0 || !stats.total) return 0;
        const cleared = stats.clear + stats.fc + stats.dfc;
        const clearRate = cleared / stats.total;
        if (clearRate < 0.15) return last;
        if (clearRate < 0.35) return Math.max(last - 1, 0);
        if (clearRate < 0.65) return Math.round(last * 0.55);
        return Math.max(Math.round(last * 0.25), 0);
    }

    private updateWeeklyRecommendations() {
        const weeklyInfo = this.getWeeklyInfo();
        this.weeklyKey = weeklyInfo.key;
        this.weeklyRangeLabel = weeklyInfo.label;
        this.weeklyBpmProfile = this.calculateBpmProfile();

        const recommendationSections = this.allSections && this.allSections.length ? this.allSections : this.sections;
        if (!recommendationSections || !recommendationSections.length) {
            this.weeklyRecommendations = [];
            return;
        }

        const recommendationStats = this.calculateSectionStats(recommendationSections);
        const targetSectionIndex = this.getWeeklyTargetSectionIndex(recommendationSections, recommendationStats);
        const maxSectionIndex = Math.max(recommendationSections.length - 1, 1);
        const candidates: any[] = [];

        recommendationSections.forEach((section, sectionIndex) => {
            for (const song of (section.songs || [])) {
                const key = this.getSongKey(song.songNo, song.difficulty);
                const crown = this.getSongCrown(song.songNo, song.difficulty);
                if (crown === 'dfc') continue;

                const score = this.getSongScore(song.songNo, song.difficulty);
                const mastery = this.getSongMastery(song.songNo, song.difficulty);
                const distanceScore = 1 - Math.min(1, Math.abs(sectionIndex - targetSectionIndex) / maxSectionIndex);
                const statusScore = crown === 'none' ? 1 : crown === 'played' ? 0.92 : crown === 'clear' ? 0.62 : 0.34;
                const scoreGap = score > 0 ? Math.max(0, Math.min(1, (950000 - score) / 450000)) : 0.72;
                const bpmInfo = this.getSongBpmInfo(song);
                let bpmScore = 0.5;
                if (this.weeklyBpmProfile.weak.includes(bpmInfo.band)) bpmScore = 0.88;
                else if (this.weeklyBpmProfile.strong.includes(bpmInfo.band)) bpmScore = 0.62;
                else if (bpmInfo.band !== 'unknown') bpmScore = 0.55;

                const weeklyJitter = this.seededUnit(`${weeklyInfo.key}:${this.currentLevel}:${key}`);
                const baseRecommendScore =
                    distanceScore * 0.30 +
                    statusScore * 0.26 +
                    scoreGap * 0.18 +
                    (1 - mastery) * 0.12 +
                    bpmScore * 0.08 +
                    weeklyJitter * 0.06;
                const scope = `level:${this.currentLevel}`;
                const popularityScore = this.getWeeklyPopularityScore(scope, key);
                const popularityCount = this.getWeeklyPopularityCount(scope, key);
                const recommendScore = this.mergeWeeklyPopularityScore(baseRecommendScore, popularityScore);

                candidates.push({
                    ...song,
                    songKey: key,
                    sectionName: section.name,
                    sectionIndex,
                    crown,
                    score,
                    mastery,
                    bpm: bpmInfo.bpm,
                    bpmBand: bpmInfo.band,
                    baseRecommendScore,
                    popularityScore,
                    popularityCount,
                    recommendScore
                });
            }
        });

        candidates.sort((a, b) => {
            if (b.recommendScore !== a.recommendScore) return b.recommendScore - a.recommendScore;
            return a.songKey.localeCompare(b.songKey);
        });
        this.weeklyRecommendations = candidates.slice(0, 6);
    }

    public getWeeklyReason(item: any): string {
        if (!item) return '';
        const section = this.getSectionDisplayName(item.sectionName);
        const bpmLabel = this.getBpmBandLabel(item.bpmBand);
        if (Number(item.popularityCount || 0) > 1) {
            return `많이 추천된 ${section} 보완곡`;
        }
        if (bpmLabel && this.weeklyBpmProfile.weak.includes(item.bpmBand)) {
            return `${bpmLabel} BPM 보완용 ${section} 추천곡`;
        }
        if (item.crown === 'none') return `${section} 미플레이 추천곡`;
        if (item.crown === 'played') return `${section} 클리어 보완곡`;
        if (item.crown === 'clear' && item.score > 0 && item.score < 950000) return `${section} 점수 갱신 추천곡`;
        if (item.crown === 'clear') return `${section} 풀콤보 도전곡`;
        if (item.crown === 'fc') return `${section} 전량 도전곡`;
        return `${section} 주간 추천곡`;
    }

    public getGenreColor(song: any): string {
        const info = this.songs[song.songNo];
        if (info && info.genres && info.genres.length > 0) {
            return this.genreColors[info.genres[0]] || '#6b7280';
        }
        return '#6b7280';
    }

    public getGenreColorList(song: any): string[] {
        const info = this.songs[song.songNo];
        if (info && info.genres && info.genres.length > 0) {
            return info.genres.map((g: string) => this.genreColors[g] || '#6b7280');
        }
        return ['#6b7280'];
    }

    public getGenreLabel(song: any): string {
        const info = this.songs[song.songNo];
        if (info && info.genres && info.genres.length > 0) {
            return info.genres.map((g: string) => this.genreLabels[g] || g).join(' / ');
        }
        return '';
    }

    public getOriginalTitle(song: any): string {
        if (song.title) return song.title;
        const info = this.songs[song.songNo];
        if (info) {
            if (info.title) return info.title;
            if (info.titleKo) return info.titleKo;
            if (info.aliasKo) return info.aliasKo;
        }
        return '';
    }

    private hasHangul(value: string | null | undefined): boolean {
        return typeof value === 'string' && /[가-힣]/.test(value);
    }

    private getPreferredTranslatedTitle(info: any): string | null {
        if (!info) return null;
        if (this.hasHangul(info.aliasKo)) return info.aliasKo;
        if (this.hasHangul(info.titleKo)) return info.titleKo;
        return info.titleKo || info.aliasKo || null;
    }

    public getTranslatedTitle(song: any): string | null {
        const info = this.songs[song.songNo];
        return this.getPreferredTranslatedTitle(info);
    }

    public getDisplayTitle(song: any): string {
        const info = this.songs[song.songNo];
        if (info) {
            const translatedTitle = this.getPreferredTranslatedTitle(info);
            if (translatedTitle) return translatedTitle;
            if (info.title) return info.title;
        }
        return song.title;
    }

    public getDifficultyIconSrc(difficulty: string): string {
        return difficulty === 'ura' ? URA_ONI_ICON_SRC : ONI_ICON_SRC;
    }

    public getDifficultyIconAlt(difficulty: string): string {
        return difficulty === 'ura' ? '뒷보면' : '앞보면';
    }

    public openChart(songNo: string, difficulty: string) {
        const url = `https://taiko.wiki/song/${songNo}?diff=${difficulty}`;
        window.open(url, '_blank');
    }

    public getYoutubeUrl(song: any): string {
        const title = this.getOriginalTitle(song);
        let query = `太鼓の達人 ${title}`;
        if (song.difficulty === 'ura') {
            query += ' 裏譜面';
        }
        return `${YOUTUBE_SEARCH_URL}?search_query=${encodeURIComponent(query)}`;
    }

    public getSectionDisplayName(name: string): string {
        return this.sectionNameMap[name] || name;
    }

    private usesLevel10DefaultBackground(section: any): boolean {
        return this.currentLevel === 10 && ['SSS', 'S', '졸업+', '최상', '최상급'].includes(section?.name);
    }

    public getSectionBackground(section: any): string {
        if (this.themeMode === 'light') return '#ffffff';
        if (this.usesLevel10DefaultBackground(section)) return '#1a1a2e';
        return section.backgroundColor && section.backgroundColor !== '#000000' ? section.backgroundColor : '#1a1a2e';
    }

    public getSectionTextColor(section: any): string {
        if (this.themeMode === 'light') return '#18181b';
        return section.color && section.color !== '#000000' ? section.color : '#e2e8f0';
    }

    // ═══════════════════════════════════════════════════
    // PNG Export — 데이터 기반 Canvas 직접 렌더링
    //
    // DOM 캡처는 브라우저/viewport/외부 스크립트 상태에 민감해서
    // 서열표 데이터를 바로 canvas에 그려 긴 PNG를 생성한다.
    // ═══════════════════════════════════════════════════

    private async canvasToPngBlob(canvas: HTMLCanvasElement): Promise<Blob> {
        return await new Promise<Blob>((resolve, reject) => {
            if (canvas.toBlob) {
                canvas.toBlob((blob) => {
                    if (blob && blob.size > 0) {
                        resolve(blob);
                    } else {
                        reject(new Error('PNG 생성 실패'));
                    }
                }, 'image/png');
                return;
            }

            const dataUrl = canvas.toDataURL('image/png');
            if (!dataUrl || dataUrl === 'data:,') {
                reject(new Error('PNG 생성 실패'));
                return;
            }

            const parts = dataUrl.split(',');
            const binary = atob(parts[1]);
            const bytes = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i++) {
                bytes[i] = binary.charCodeAt(i);
            }
            resolve(new Blob([bytes], { type: 'image/png' }));
        });
    }

    private async downloadCanvasAsPng(canvas: HTMLCanvasElement, filename: string) {
        const blob = await this.canvasToPngBlob(canvas);
        const nav = window.navigator as any;

        if (nav.msSaveOrOpenBlob) {
            nav.msSaveOrOpenBlob(blob, filename);
            return;
        }

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.rel = 'noopener';
        link.style.display = 'none';

        document.body.appendChild(link);
        link.click();
        link.remove();

        setTimeout(() => URL.revokeObjectURL(url), 1000);
    }

    private async loadExportImage(src: string): Promise<HTMLImageElement> {
        return await new Promise<HTMLImageElement>((resolve, reject) => {
            const image = new Image();
            image.crossOrigin = 'anonymous';
            image.decoding = 'async';
            image.onload = () => {
                if (image.naturalWidth > 0 && image.naturalHeight > 0) {
                    resolve(image);
                } else {
                    reject(new Error(`아이콘 이미지 로드 실패: ${src}`));
                }
            };
            image.onerror = () => reject(new Error(`아이콘 이미지 로드 실패: ${src}`));
            image.src = src;
        });
    }

    private async loadDifficultyIconImages(): Promise<{ oni: HTMLImageElement; ura: HTMLImageElement }> {
        if (!this.difficultyIconImagePromise) {
            this.difficultyIconImagePromise = Promise.all([
                this.loadExportImage(ONI_ICON_SRC),
                this.loadExportImage(URA_ONI_ICON_SRC)
            ])
                .then(([oni, ura]) => ({ oni, ura }))
                .catch((error) => {
                    this.difficultyIconImagePromise = null;
                    throw error;
                });
        }
        return await this.difficultyIconImagePromise;
    }

    public async exportChart() {
        if (this.exportingChart || this.loading) return;
        this.exportingChart = true;
        this.applySectionFilters();
        this.updateLevelStats();
        await this.service.render();

        try {
            await ((document as any).fonts?.ready || Promise.resolve());
            const difficultyIcons = await this.loadDifficultyIconImages();

            const CW = 1440;
            const margin = 44;
            const contentW = CW - (margin * 2);
            const cols = 6;
            const cardGap = 3;
            const cardW = Math.floor((contentW - (cardGap * (cols - 1))) / cols);
            const cardH = 76;
            const headerH = 188;
            const sectionHeaderH = 42;
            const sectionGap = 18;
            const footerH = 64;
            const fontFamily = 'SUIT, "Noto Sans KR", "Noto Sans JP", Arial, sans-serif';
            const visibleSections = (this.sections || []).filter((section: any) => section && Array.isArray(section.songs));
            if (!visibleSections.length || visibleSections.every((section: any) => section.songs.length === 0)) {
                throw new Error('저장할 서열표 데이터가 없습니다');
            }

            let totalH = headerH + footerH;
            for (const section of visibleSections) {
                const rows = Math.max(1, Math.ceil(section.songs.length / cols));
                totalH += sectionHeaderH + (rows * cardH) + ((rows - 1) * cardGap) + sectionGap;
            }

            const maxCanvasSide = 16000;
            const maxCanvasArea = 16000000;
            const exportScale = Math.min(
                1,
                maxCanvasSide / Math.max(CW, totalH),
                Math.sqrt(maxCanvasArea / (CW * totalH))
            );

            const canvas = document.createElement('canvas');
            canvas.width = Math.max(1, Math.floor(CW * exportScale));
            canvas.height = Math.max(1, Math.floor(totalH * exportScale));
            const ctx = canvas.getContext('2d')!;
            ctx.scale(exportScale, exportScale);
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';

            const roundRect = (x: number, y: number, w: number, h: number, r: number) => {
                const radius = Math.min(r, w / 2, h / 2);
                ctx.beginPath();
                ctx.moveTo(x + radius, y);
                ctx.lineTo(x + w - radius, y);
                ctx.quadraticCurveTo(x + w, y, x + w, y + radius);
                ctx.lineTo(x + w, y + h - radius);
                ctx.quadraticCurveTo(x + w, y + h, x + w - radius, y + h);
                ctx.lineTo(x + radius, y + h);
                ctx.quadraticCurveTo(x, y + h, x, y + h - radius);
                ctx.lineTo(x, y + radius);
                ctx.quadraticCurveTo(x, y, x + radius, y);
                ctx.closePath();
            };

            const fillRoundRect = (x: number, y: number, w: number, h: number, r: number, fill: string | CanvasGradient) => {
                roundRect(x, y, w, h, r);
                ctx.fillStyle = fill;
                ctx.fill();
            };

            const strokeRoundRect = (x: number, y: number, w: number, h: number, r: number, stroke: string, lineWidth = 1) => {
                roundRect(x, y, w, h, r);
                ctx.strokeStyle = stroke;
                ctx.lineWidth = lineWidth;
                ctx.stroke();
            };

            const fitText = (text: string, x: number, y: number, maxW: number) => {
                let value = text || '';
                if (ctx.measureText(value).width <= maxW) {
                    ctx.fillText(value, x, y);
                    return;
                }
                while (value.length > 0 && ctx.measureText(value + '...').width > maxW) {
                    value = value.slice(0, -1);
                }
                ctx.fillText(value + '...', x, y);
            };

            const drawCrown = (x: number, y: number, size: number, crown: string) => {
                if (crown === 'none') {
                    strokeRoundRect(x + 2, y + 2, size - 4, size - 4, 3, '#52525b');
                    return;
                }

                const fill = crown === 'dfc'
                    ? (() => {
                        const g = ctx.createLinearGradient(x, y, x + size, y);
                        ['#ff6b6b', '#ffa500', '#ffd700', '#48bb78', '#4299e1', '#9f7aea'].forEach((c, i) => g.addColorStop(i / 5, c));
                        return g;
                    })()
                    : (crown === 'played' ? '#CD7F32' : crown === 'clear' ? '#C0C0C0' : '#FFD700');

                ctx.save();
                ctx.fillStyle = fill;
                ctx.beginPath();
                ctx.moveTo(x + size * 0.16, y + size * 0.66);
                ctx.lineTo(x + size * 0.08, y + size * 0.22);
                ctx.lineTo(x + size * 0.33, y + size * 0.44);
                ctx.lineTo(x + size * 0.5, y + size * 0.14);
                ctx.lineTo(x + size * 0.67, y + size * 0.44);
                ctx.lineTo(x + size * 0.92, y + size * 0.22);
                ctx.lineTo(x + size * 0.84, y + size * 0.66);
                ctx.closePath();
                ctx.fill();
                fillRoundRect(x + size * 0.17, y + size * 0.72, size * 0.66, size * 0.16, 2, fill);
                ctx.restore();
            };

            const drawDifficulty = (x: number, y: number, difficulty: string) => {
                const isUra = difficulty === 'ura';
                const icon = isUra ? difficultyIcons.ura : difficultyIcons.oni;
                ctx.drawImage(icon, x, y, 20, 20);
            };

            const getCardFill = (crown: string) => {
                switch (crown) {
                    case 'played': return '#21150c';
                    case 'clear': return '#27272f';
                    case 'fc': return '#241d0a';
                    case 'dfc': return '#17172f';
                    default: return '#18181b';
                }
            };

            ctx.fillStyle = '#09090b';
            ctx.fillRect(0, 0, CW, totalH);

            fillRoundRect(margin, 24, contentW, 132, 8, '#18181b');
            ctx.fillStyle = '#f4f4f5';
            ctx.font = `800 34px ${fontFamily}`;
            ctx.fillText(`태고의 달인 서열표 ★${this.currentLevel}`, margin + 28, 72);
            ctx.fillStyle = '#a1a1aa';
            ctx.font = `500 16px ${fontFamily}`;
            ctx.fillText(`총 ${this.levelStats.total}곡 · 불클리어 ${this.levelStats.played} · 클리어 ${this.levelStats.clear} · 풀콤보 ${this.levelStats.fc} · 전량 ${this.levelStats.dfc}`, margin + 28, 104);

            const legendY = 128;
            const legend = [
                { key: 'none', label: '미플레이' },
                { key: 'played', label: '불클리어' },
                { key: 'clear', label: '클리어' },
                { key: 'fc', label: '풀콤보' },
                { key: 'dfc', label: '전량' }
            ];
            let legendX = margin + 28;
            ctx.font = `600 13px ${fontFamily}`;
            for (const item of legend) {
                drawCrown(legendX, legendY - 15, 18, item.key);
                ctx.fillStyle = '#d4d4d8';
                ctx.fillText(item.label, legendX + 24, legendY);
                legendX += ctx.measureText(item.label).width + 54;
            }

            let y = headerH;
            for (const section of visibleSections) {
                const rows = Math.max(1, Math.ceil(section.songs.length / cols));
                const sectionH = sectionHeaderH + (rows * cardH) + ((rows - 1) * cardGap);
                const sectionBg = this.usesLevel10DefaultBackground(section)
                    ? '#1a1a2e'
                    : section.backgroundColor && section.backgroundColor !== '#000000' ? section.backgroundColor : '#1a1a2e';
                const sectionText = section.color && section.color !== '#000000' ? section.color : '#e2e8f0';
                const stats = this.getSectionStats(section);

                fillRoundRect(margin, y, contentW, sectionH, 8, '#121216');
                fillRoundRect(margin, y, contentW, sectionHeaderH, 8, sectionBg);
                ctx.fillStyle = sectionText;
                ctx.font = `800 20px ${fontFamily}`;
                ctx.fillText(this.getSectionDisplayName(section.name), margin + 20, y + 27);
                ctx.font = `600 14px ${fontFamily}`;
                ctx.fillText(`${section.songs.length}곡 · ${stats.cleared}/${stats.total}`, margin + contentW - 140, y + 26);

                const gridY = y + sectionHeaderH;
                section.songs.forEach((song: any, idx: number) => {
                    const col = idx % cols;
                    const row = Math.floor(idx / cols);
                    const x = margin + (col * (cardW + cardGap));
                    const cy = gridY + (row * (cardH + cardGap));
                    const crown = this.getSongCrown(song.songNo, song.difficulty);
                    const score = this.getSongScore(song.songNo, song.difficulty);

                    fillRoundRect(x, cy, cardW, cardH, 3, getCardFill(crown));
                    ctx.strokeStyle = '#27272a';
                    ctx.lineWidth = 1;
                    ctx.strokeRect(x + 0.5, cy + 0.5, cardW - 1, cardH - 1);

                    const genreColors = this.getGenreColorList(song);
                    const barH = cardH / genreColors.length;
                    genreColors.forEach((color: string, gi: number) => {
                        ctx.fillStyle = color;
                        ctx.fillRect(x, cy + (gi * barH), 5, Math.ceil(barH));
                    });

                    drawDifficulty(x + 12, cy + 12, song.difficulty);
                    drawCrown(x + 38, cy + 12, 20, crown);

                    ctx.textAlign = 'left';
                    ctx.textBaseline = 'alphabetic';
                    ctx.font = `800 14px ${fontFamily}`;
                    ctx.fillStyle = crown === 'none' ? '#f4f4f5' : '#e4e4e7';
                    fitText(this.getOriginalTitle(song), x + 64, cy + 28, cardW - 76);

                    const translatedTitle = this.getTranslatedTitle(song);
                    if (translatedTitle) {
                        ctx.font = `500 12px ${fontFamily}`;
                        ctx.fillStyle = '#a1a1aa';
                        fitText(translatedTitle, x + 12, cy + 50, cardW - 24);
                    }

                    if (score > 0) {
                        ctx.font = `700 12px ${fontFamily}`;
                        if (this.isRainbowScore(score)) {
                            const scoreGradient = ctx.createLinearGradient(x + 12, cy + 63, x + 96, cy + 63);
                            ['#ff6b6b', '#ffa500', '#ffd700', '#48bb78', '#4299e1', '#9f7aea'].forEach((c, i) => scoreGradient.addColorStop(i / 5, c));
                            ctx.fillStyle = scoreGradient;
                        } else {
                            ctx.fillStyle = this.getScoreColor(score);
                        }
                        fitText(this.formatScore(score), x + 12, cy + 67, cardW - 24);
                    }
                });

                y += sectionH + sectionGap;
            }

            ctx.fillStyle = '#52525b';
            ctx.font = `500 13px ${fontFamily}`;
            ctx.textAlign = 'center';
            ctx.fillText('서열표 데이터 출처: taiko.wiki', CW / 2, totalH - 34);

            const d = new Date();
            const ds = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
            const filename = `태고서열표_★${this.currentLevel}_${ds}.png`;
            await this.downloadCanvasAsPng(canvas, filename);

        } catch (e) {
            console.error('Export failed:', e);
            const msg = e instanceof Error ? e.message : String(e);
            alert('이미지 저장 실패: ' + msg);
        } finally {
            this.exportingChart = false;
            await this.service.render();
        }
    }

    public openHirobaUpdateModal() {
        this.hirobaUpdateModalOpen = true;
        this.hirobaBookmarkletCode = this.buildHirobaBookmarkletCode();
        this.loadHirobaUpdateStatus(false);
        this.service.render();
    }

    public closeHirobaUpdateModal() {
        this.hirobaUpdateModalOpen = false;
        this.service.render();
    }

    private jsStringLiteral(value: string): string {
        return JSON.stringify(String(value || ''));
    }

    private buildHirobaBookmarkletCode(token: string = this.hirobaUpdateToken, autoStart: boolean = !!this.hirobaUpdateToken): string {
        const origin = window.location.origin.replace(/\/$/, '');
        const commands = [
            `window.__TAIGO_TAIKO_ORIGIN=${this.jsStringLiteral(origin)}`,
            token ? `window.__TAIGO_TAIKO_TOKEN=${this.jsStringLiteral(token)}` : '',
            `window.__TAIGO_TAIKO_AUTO_START=${autoStart && !!token ? 'true' : 'false'}`,
            'window.__TAIGO_TAIKO_AUTO_CLOSE=true',
            'var s=document.createElement("script")',
            's.src=window.__TAIGO_TAIKO_ORIGIN+"/assets/taiko-updater.js?ts="+Date.now()',
            '(document.head||document.documentElement).appendChild(s)'
        ].filter(Boolean);
        return `javascript:(function(){${commands.join(';')};})()`;
    }

    private updateHirobaBookmarkletCode() {
        this.hirobaBookmarkletCode = this.buildHirobaBookmarkletCode();
    }

    private writeClipboardTextFallback(text: string): boolean {
        const activeElement = document.activeElement as HTMLElement | null;
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '0';
        textarea.style.left = '0';
        textarea.style.width = '1px';
        textarea.style.height = '1px';
        textarea.style.opacity = '0';
        textarea.style.pointerEvents = 'none';

        try {
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            textarea.setSelectionRange(0, textarea.value.length);
            return document.execCommand('copy');
        } catch {
            return false;
        } finally {
            textarea.remove();
            try {
                if (activeElement && activeElement.focus) activeElement.focus();
            } catch { }
        }
    }

    private async writeClipboardText(text: string): Promise<boolean> {
        if (!text) return false;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            try {
                await navigator.clipboard.writeText(text);
                return true;
            } catch {
                return this.writeClipboardTextFallback(text);
            }
        }
        return this.writeClipboardTextFallback(text);
    }

    private markHirobaCopiedTarget(target: string) {
        this.hirobaCopiedTarget = target;
        window.setTimeout(async () => {
            if (this.hirobaCopiedTarget === target) {
                this.hirobaCopiedTarget = '';
                await this.service.render();
            }
        }, 1400);
    }

    public async copyHirobaText(text: string, target: string) {
        const copied = await this.writeClipboardText(text);
        if (copied) {
            this.markHirobaCopiedTarget(target);
        } else {
            this.hirobaUpdateStatusMessage = target === 'bookmarklet'
                ? '복사에 실패했습니다. 스크립트 칸을 직접 선택해 복사해주세요.'
                : '복사에 실패했습니다.';
        }
        await this.service.render();
    }

    private latestHirobaUpdatedMillis(): number {
        const latest = this.hirobaUpdateInfo && this.hirobaUpdateInfo.latest;
        const value = latest && latest.updated;
        if (!value) return 0;
        const millis = new Date(value).getTime();
        return Number.isNaN(millis) ? 0 : millis;
    }

    private stopHirobaUpdateStatusPolling() {
        if (this.hirobaUpdatePollTimer) {
            window.clearInterval(this.hirobaUpdatePollTimer);
            this.hirobaUpdatePollTimer = null;
        }
        this.hirobaUpdatePollStartedAt = 0;
    }

    private startHirobaUpdateStatusPolling() {
        this.stopHirobaUpdateStatusPolling();
        this.hirobaUpdatePollStartedAt = Date.now();
        this.hirobaUpdatePollTimer = window.setInterval(async () => {
            if (Date.now() - this.hirobaUpdatePollStartedAt > HIROBA_UPDATE_POLL_TIMEOUT_MS) {
                this.stopHirobaUpdateStatusPolling();
                return;
            }
            await this.pollHirobaUpdateStatus();
        }, HIROBA_UPDATE_POLL_INTERVAL_MS);
    }

    private async pollHirobaUpdateStatus() {
        const before = this.latestHirobaUpdatedMillis();
        await this.loadHirobaUpdateStatus(false);
        const after = this.latestHirobaUpdatedMillis();
        if (after > Math.max(before, this.hirobaUpdateBaselineUpdatedAt)) {
            this.stopHirobaUpdateStatusPolling();
            await this.loadSongData();
            this.applySectionFilters();
            this.updateLevelStats();
            this.updateWeeklyRecommendations();
            this.hirobaUpdateStatusMessage = '동더히로바 기록 저장 완료. 서열표에 반영했습니다.';
            await this.service.render();
        }
    }

    public async loadHirobaUpdateStatus(showMessage: boolean = true) {
        try {
            const { code, data } = await wiz.call("load_update_status", { _ts: Date.now() });
            if (code === 200 && data) {
                this.hirobaUpdateInfo = data;
                if (showMessage) this.hirobaUpdateStatusMessage = '최신 기록 상태를 확인했습니다.';
            } else if (showMessage) {
                this.hirobaUpdateStatusMessage = data?.message || '최신 기록 확인에 실패했습니다.';
            }
        } catch {
            if (showMessage) this.hirobaUpdateStatusMessage = '최신 기록 확인에 실패했습니다.';
        }
        if (showMessage) await this.service.render();
    }

    public async generateHirobaUpdateToken() {
        if (!this.isLoggedIn) {
            this.hirobaUpdateStatusMessage = '로그인 후 사용할 수 있습니다.';
            await this.service.render();
            return;
        }

        this.hirobaUpdateLoading = true;
        this.hirobaUpdateStatusMessage = '';
        this.hirobaUpdateBaselineUpdatedAt = this.latestHirobaUpdatedMillis();
        await this.service.render();

        try {
            const { code, data } = await wiz.call("generate_update_token", { _ts: Date.now() });
            if (code === 200 && data) {
                this.hirobaUpdateToken = data.token || '';
                this.hirobaUpdateTokenExpires = data.expires || '';
                this.updateHirobaBookmarkletCode();
                this.hirobaUpdateStatusMessage = '토큰을 발급했습니다.';
                this.startHirobaUpdateStatusPolling();
            } else {
                this.hirobaUpdateStatusMessage = data?.message || '토큰 발급에 실패했습니다.';
            }
        } catch {
            this.hirobaUpdateStatusMessage = '토큰 발급에 실패했습니다.';
        }

        this.hirobaUpdateLoading = false;
        await this.loadHirobaUpdateStatus(false);
        this.updateHirobaBookmarkletCode();
        await this.service.render();
    }

    private focusHirobaUpdateWindow(popup: Window | null, focus: boolean = true) {
        if (!popup) return;
        this.hirobaUpdateWindow = popup;
        if (!focus) return;
        try {
            popup.focus();
        } catch { }
    }

    private openHirobaSessionWindow(url: string = HIROBA_HOME_URL): Window | null {
        const popup = window.open(url, HIROBA_WINDOW_NAME, HIROBA_WINDOW_FEATURES);
        if (popup) {
            try {
                if (popup.location.href === 'about:blank') {
                    popup.location.replace(url);
                }
            } catch { }
        }
        this.focusHirobaUpdateWindow(popup);
        return popup;
    }

    private async ensureHirobaUpdateToken(): Promise<boolean> {
        if (this.hirobaUpdateToken) {
            this.updateHirobaBookmarkletCode();
            return true;
        }
        await this.generateHirobaUpdateToken();
        return !!this.hirobaUpdateToken;
    }

    public async openHirobaUpdateWindow() {
        const popup = this.openHirobaSessionWindow();
        if (!popup) {
            this.hirobaUpdateStatusMessage = '새창이 차단되었습니다. 팝업 허용 후 다시 시도해주세요.';
            await this.service.render();
            return;
        }

        this.hirobaUpdateLoading = !this.hirobaUpdateToken;
        this.hirobaUpdateStatusMessage = '';
        await this.service.render();

        const ready = await this.ensureHirobaUpdateToken();
        this.hirobaUpdateLoading = false;
        await this.loadHirobaUpdateStatus(false);
        this.updateHirobaBookmarkletCode();
        if (!ready) {
            await this.service.render();
            return;
        }
        this.hirobaUpdateStatusMessage = '동더히로바 창을 열었습니다. 로그인 후 스크립트를 복사해 주소창에서 실행해주세요.';
        this.startHirobaUpdateStatusPolling();
        await this.service.render();
    }

}

export default PageTaikoComponent;